<template>
    <div v-if="getPermission.stc.view || getPermission.stcExtraCost.view">  


     <yard-export-form ref="CreateIngate" mode="Booking"/>
    <yard-export-form ref="Instruction" mode="Instruction"/>

    <dispatch-form ref="DispatchForm" mode="YY" action = "CREATE"/>
    <dispatch-form ref="DispatchFormCopy" mode="YY" action = "COPY"/>
    <dispatch-form ref="DispatchFormChange" mode="YY" action = "CHANGE"/>
    <outbound-booking ref="OutboundBooking" mode="YY" :action="onfresh"/>
    <outbound-booking ref="OutboundBookingYE" mode="YE" :action="onfresh"/>
    <outbound-booking ref="OutboundBookingYI" mode="YI" :action="onfresh"/>
    <outbound-booking ref="OutboundBookingYT" mode="YT" :action="onfresh"/>

    <update-driver-group-form ref="UpdateDriverGroupForm" mode="YY" :onUpdate="updateDriverGroup"/>
    <update-stc-container-status-form ref="UpdateStcContainerStatusForm" :action="onRefreshLoadStatus"/>
    <load-status-log ref="LoadStatusLog"></load-status-log>

    <md-dialog :md-active.sync="isPictureModalShowing">
      <md-dialog-content>
        <span class="heading2">{{photoTitle}}</span>
        <calling-api path="/api/w/ccr/photo/getCCRPhoto">
        <div v-if="photos.length === 0">
          <h3>You don't have any photos from CCR Log</h3>
        </div>
        <div v-else>
          <view-image  :key="p.imgUrl" :src="p.imgUrl" v-for="p in photos">
           <div v-if="!isLoading" class="space">
              <h3>Type: {{p.title}}</h3>
              <p>File Name: {{getPhotoName(p)}}</p>
            </div>
            <div v-if="isLoading" class="space">
              <p>File Name: {{getPhotoName(p)}}</p>
              <p>{{p.refTimeStamp}}</p>
            </div>            
          </view-image>
        </div>
          
        </calling-api>
      </md-dialog-content>
      <md-dialog-actions>
        <download-pictures-button :zip-file-name="photoZipFileName"
                                  :file-prefix-for-each-file="filePrefixForEachFile"
                                  :pics="photos.map(it=>it.photoUrl)"
                                  v-if="isLoading"/>
        <md-button class="md-primary" @click="isPictureModalShowing = false; isLoading = false;">Close</md-button>      </md-dialog-actions>
    </md-dialog>


    <md-card class="searchPanel">
      <md-card-content>
        <div class="md-layout md-gutter">
          <!-- search criteria fields start --> 
          <!--<div v-if="active" style="margin-left: 200px; width:100%">-->
             <!-- Date session -->
             <div v-if="active" class="md-layout-item md-size-20 md-small-size-100">
               <div class = "inputBox">
                 <auto-complete-master-data-multiple-select
                     label="Status"
                     :prepared-options="this.getMasterDataAsSelectOptionByGroup('GST_LOAD_STATUS')"
                     v-model="searchRequest.loadStatus"
                 />
               </div>
               <div class = "inputBox" >
                    <auto-complete-master-data-select
                        group="REC_WINDOW"
                        label="Rev. Windows"
                        :init-value="searchRequest.receivingWindow"
                        :on-item-changed="handleWindowsChanged"
                    >
                    </auto-complete-master-data-select>
                </div>
                <div class = "inputBox">
                   <auto-complete-master-data-select
                      group="PUSH_STATUS"
                      label="Push Status"
                      :init-value="searchRequest.pushStatus"
                      :on-item-changed="handlePushStatusChanged"
                   >
                   </auto-complete-master-data-select>
                </div>
             </div>
             <div v-if="active" class="md-layout-item md-size-20 md-small-size-100">
                <div class = "inputBox" >
                   <datepicker v-model="searchRequest.moveInDate.startDate" >
                      <label>Move In Date</label>
                   </datepicker>
                </div>
                <div class = "inputBox" >
                   <datepicker v-model="searchRequest.inGateDate.startDate" >
                      <label>In Gate Date</label>
                   </datepicker>
                </div>
                <div class = "inputBox">
                    <md-field>
                       <label>Chassis #</label>
                       <md-input v-model="searchRequest.chassisNo"/>
                    </md-field>
                </div>
                <div class = "inputBox">
                    <md-field>
                       <label>Booking #</label>
                       <md-input v-model="searchRequest.bookingNo" />
                    </md-field>
                </div>
                <div class = "inputBox">
                    <md-field>
                       <label>STC DO</label>
                       <md-input v-model="searchRequest.deliveryOrder"/>
                    </md-field>
                </div>

             </div>
             <div v-if="active" class="md-layout-item md-size-20 md-small-size-100">
                <div class = "inputBox" >
                   <datepicker v-model="searchRequest.moveInDate.endDate">
                      <label>Move In Date To</label>
                   </datepicker>
                </div>
                <div class = "inputBox" >
                   <datepicker v-model="searchRequest.inGateDate.endDate">
                      <label>In Gate Date To</label>
                   </datepicker>
                </div>
                <div class = "inputBox">
                   <md-field>
                      <label>Load Key</label>
                      <md-input v-model="searchRequest.loadKey" />
                   </md-field>
                </div>
                <div class = "inputBox">
                   <auto-complete-master-data-select
                       label="Carrier Name"
                       display-type="idOnly"
                       :prepared-options="this.getMasterDataAsSelectOptionByGroup('STC_CARRIER')"
                       :init-value-id="searchRequest.carrier"
                       :on-item-changed="handleCarrierChanged">
                   </auto-complete-master-data-select>
                </div>
                <div class = "inputBox">
                   <md-field>
                      <label>Customer Order</label>
                      <md-input v-model="searchRequest.customerOrder"/>
                   </md-field> 
                </div>
             </div>
             <div v-if="active" class="md-layout-item md-size-20 md-small-size-100">
                <div class = "inputBox" >
                   <datepicker v-model="searchRequest.cargoCutOff.startDate">
                      <label>Cargo Cut Date</label>
                   </datepicker>
                </div>
                <div class = "inputBox">
                   <md-field>
                     <label>Container#</label>
                     <md-input v-model="searchRequest.containerNo"/>
                   </md-field>
                </div>
                <div class = "inputBox">
                   <md-field>
                     <label>Pick up Location</label>
                     <md-input v-model="searchRequest.pickupLocation"/>
                   </md-field>
                </div>
                <div class = "inputBox" >
                   <auto-complete-stc-driver-group-select
                      label="Driver Group"
                      :options="stcDriverGroupOption"
                      v-model="searchRequest.driverGroup"
                   >
                   </auto-complete-stc-driver-group-select>
                </div>
             </div>
             <div v-if="active" class="md-layout-item md-size-20 md-small-size-100">
                <div class = "inputBox" >
                   <datepicker v-model="searchRequest.cargoCutOff.endDate">
                      <label>Cargo Cut Date To</label>
                   </datepicker>
                </div>
                <div class = "inputBox" >
                   <auto-complete-master-data-select
                        group="CCR_CNTRTYPE"
                        label="Container Type"
                        :init-value="searchRequest.ctnrType"
                        :on-item-changed="handleCtnrTypeChanged"
                    >
                    </auto-complete-master-data-select>
                </div>
                <div class = "inputBox">
                    <md-field>
                    <label>Destination</label>
                    <md-input v-model="searchRequest.destination" />
                    </md-field>
                </div>
                <div class = "inputBox">
                   <auto-complete-select
                     :options="drivers"
                     label="Driver"
                     :value="searchRequest.driverId"
                     :on-item-changed="handleDriverRequestChanged"
                    >
                   </auto-complete-select>
                </div>

              </div>

          <!--</div>-->

          <!-- Search button start -->
          <div v-if="getPermission.ccic.edit || getPermission.stc.view" class="md-layout-item md-size-100 md-small-size-100">
             <div class="result-included-outter-div bg-col">
                <div class="result-included-inner-div-radio">
                   <span class="result-included-span-radio bgtype"> 
                      Dispatch Type: 
                   </span>
                   <md-radio v-model="selectDType" value="YE"  @change="onSelectDType" ><span v-bind:class="{ bgye: this.selectDType == 'YE' }">Yard Export</span></md-radio>
                   <md-radio v-model="selectDType" value="E"  @change="onSelectDType" ><span v-bind:class="{ bge: this.selectDType == 'E' }">Export</span></md-radio>  
                   <md-radio v-model="selectDType" value="I"  @change="onSelectDType" ><span v-bind:class="{ bgi: this.selectDType == 'I' }">Import</span></md-radio>  
                   <md-radio v-model="selectDType" value="TL"  @change="onSelectDType" ><span v-bind:class="{ bgtl: this.selectDType == 'TL' }">Truck Load</span></md-radio>  
                </div>
             </div>
             <div style="margin-top: -36px; margin-left: 650px;">
               <md-checkbox v-model="bobtailOnly">BobTail Only</md-checkbox>
             </div>
             <div  style="margin-left: 800px; height: 5px; margin-top: -50px;">
                <callingApiCenter :paths="['/api/w/gst/yardexportlist', '/api/w/gst/WebSearchDispatchList', '/api/w/DOs/WebUnAssignBooking']">
                    <callingApiCenter path=" /api/w/gst/loadlist/create" :not-display-error="true">  
                    </callingApiCenter>
                </callingApiCenter>
              </div>
          </div>


          <div v-if="getPermission.ccic.edit || getPermission.stc.view" class="md-layout-item md-size-100 md-small-size-100 gapupper">
             <!--<callingApiCenter :paths="['/api/w/gst/yardexportlist', '/api/w/gst/WebSearchDispatchList', '/api/w/DOs/WebUnAssignBooking']">-->
                <!--<callingApiCenter path=" /api/w/gst/loadlist/create" :not-display-error="true">-->
                  <b-notification class = "notifySize"
                     type="is-success"
                     v-model="notifyActive"
                     aria-close-label="Close notification">
                     {{notifyMessage}}
                  </b-notification>

                  <md-button
                     class="custButton md-raised"
                     @click="getBookingAssign()"
                     :disabled="!getAssignBookingCond || !this.getPermission.stcClerk.view"
                  > 
                     Assign BK
                  </md-button>
                  <md-button 
                     class="custButton md-raised"
                     @click="getBookingUnAssign()"
                     :disabled="!getUnAssignBookingCond || !this.getPermission.stcClerk.view"
                  > 
                      Un-Assign
                  </md-button>
                  
                  <div class="dropdown">
                      <md-button :disabled="!this.getPermission.stcClerk.view" class="md-raised custButton " @click="doDropDown">...  <span class="icons-center material-icons">add</span></md-button>
                      <!--
                      <div id="dropdown" class="dropdown-content" v-if="showDropDown">
                         <a href="#" id="dd_li" @click="editAppt" disabled="!canEdit">Appointment</a>
                         <a href="#" @click="editDriverGroup">Driver Group</a>
                         <a href="#" @click="doAsgDriver">Assign Driver</a>
                         <a href="#" @click="doAdditionCharge">Add Addition Charge</a>
                      </div>
                    --> 
                  </div>
                  

                  <md-button class="md-raised custButton" :disabled="canSave || !this.getPermission.stcClerk.view" @click="doSave" ><span class="icons-center material-icons"  >save</span>Save</md-button>
                  <md-button class="md-raised custMedButton" :disabled="!canEdit || !this.getPermission.stcClerk.view && !this.getPermission.stcoptfsireadonly.view" @click="doCockPit" ><span class="icons-center material-icons"  >grid_view</span>Cockpit</md-button>
                  <md-button class="md-raised custMedButton" :disabled="this.getSelectedItems.length > 0" @click="doBobTailEmpty" ><span class="icons-center material-icons"  >local_shipping</span>BobTail</md-button>
                  <md-button class="md-raised custButton" @click="doStage" ><span class="icons-center material-icons"  >toc</span>Stage</md-button>
                  <!--<md-button class="md-raised custButton" @click="doPIN" :disabled="canDoPIN || !this.getPermission.stcClerk.view" ><span class="icons-center material-icons"  >view_in_ar</span>PIN</md-button>-->
                  <md-button class="md-raised custButton" @click="doConfirm" :disabled="!this.getPermission.stcClerk.view" ><span class="icons-center material-icons"  >playlist_add_check</span>Confirm</md-button>
                  <md-button class="md-raised custButton" v-if="allowUpdateLoadStatus()" @click="doUpdateStatus" :disabled="!this.getPermission.stcClerk.view || this.checkUpdateLoadStatus()" ><span class="icons-center material-icons"  >create</span>Status</md-button>
                  <md-button id = "searchTag" @click="doSearch"  class=" custButton btn-search-special-form-container md-primary md-raised">Search</md-button>
                  <md-button   @click="doClear" class="md-raised custButton">Clear</md-button>
                  <md-button
                     class="custButton md-raised"
                     @click="doDownloadExcel"
                     :disabled="!getDownloadCond"
                  > 
                    Download
                  </md-button>
                  <input class = "custSearchBar" type="text"
                     placeholder="Searching Term"
                     v-model="filter"
                  />
                  <md-button class="md-icon-button custButtonRight" @click="mouseLeave" id="expand-button">
                      <md-icon v-if="active == false">keyboard_arrow_down</md-icon>
                      <md-icon v-if="active == true">keyboard_arrow_up</md-icon>
                  </md-button>

                <!--</callingApiCenter>-->
             <!--</callingApiCenter>-->
          </div>          

          <!-- search criteria fields end -->
        </div>
      </md-card-content>
    </md-card>
        <pagination :items="filteredRows">
      <template slot-scope="{pageItems}">
        <md-card class="data-table-container setzindex">
          <div class="outer-container ">
            <div class="inner-container table-wrapper ">
              <div class="table-header">
                <table id="headertable">
                  <thead>
                  <tr class="table-container">
                    <th class="header-cell w2 fix">
                      <md-checkbox v-model="selectAll" @change="changeSelChkBox" class="fix"></md-checkbox>
                      <md-tooltip md-direction="top">Select All/DeSelect All</md-tooltip>
                    </th>
                    <th class="header-cell center w2 table-container-th">Doc Due</th>
                    <th class="header-cell center w5 table-container-th" v-on:click="sortFunction('salesOffice')">Sales Office</th>
                    <th class="header-cell center w5 table-container-th" v-on:click="sortFunction('deliveryType')">Delivery Type</th>
                    <th class="header-cell center w5 table-container-th" v-on:click="sortFunction('receivingWindows')">Receiving Window</th>
                    <th class="header-cell center w5 table-container-th" v-on:click="sortFunction('loadStatus')">Load Status</th>
                    <th class="header-cell center w5 table-container-th" v-on:click="sortFunction('stageStatus')">Stage Count</th>
                    <!--<th class="header-cell center w5" v-on:click="sortFunction('seqNo')">Load Key</th>-->
                    <th class="header-cell center w8 table-container-th" v-on:click="sortFunction('containerNo')">Container</th>
                    <th class="header-cell center w8 table-container-th" v-on:click="sortFunction('chassisNo')">Chassis</th>
                    <th class="header-cell center w10 table-container-th" v-on:click="sortFunction('additionCharge')">Load Additional Charges</th>
                    <th class="header-cell center w5 table-container-th" v-on:click="sortFunction('carrier')">Carrier</th>
                    <th class="header-cell center w5 table-container-th" v-on:click="sortFunction('loadBookingCarrier')">BK Carrier</th>
                    <th class="header-cell center w5 table-container-th" v-on:click="sortFunction('grade')">Grade</th>
                    <th class="header-cell center w5 table-container-th" v-on:click="sortFunction('loadBookingGrade')">BK Grade</th>
                    <th class="header-cell center w5 table-container-th" v-on:click="sortFunction('specGrade')">Special Grade</th>
                    <th class="header-cell center w10 table-container-th" v-on:click="sortFunction('bookingNo')">Booking #</th>
                    <th class="header-cell center w10 table-container-th" v-on:click="sortFunction('bookingNo')">EPT Pulled Booking #</th>
                    <th class="header-cell center w5 table-container-th" v-on:click="sortFunction('bookingNo')">Bk Mismatch</th>
                    <th class="header-cell center w5 table-container-th" v-on:click="sortFunction('docCut')">Doc Cut-off Date</th>
                    <th class="header-cell center w5 table-container-th" v-on:click="sortFunction('cutLFD')">Cargo Cut-off Date</th>
                    <th class="header-cell center w5 table-container-th" v-on:click="sortFunction('appointment')">Appointment</th>
                    <th class="header-cell center w8 table-container-th" v-on:click="sortFunction('apptDate')">Appt Date</th>
                    <th class="header-cell center w5 table-container-th"  v-on:click="sortFunction('apptTime')">Appt Time</th>
                    <th class="header-cell center w10 table-container-th"  v-on:click="sortFunction('driverGroup')">Driver Group</th>
                    <th class="header-cell center w10 table-container-th" v-on:click="sortFunction('driverId')">Driver</th>
                    <th class="header-cell center w5 table-container-th" v-on:click="sortFunction('push')">Push</th>
                    <th class="header-cell center w5 table-container-th" v-on:click="sortFunction('confirm')">Request</th>
                    <th class="header-cell center w5 table-container-th" v-on:click="sortFunction('confirm')">Reject</th>
                    <th class="header-cell center w5 table-container-th" v-on:click="sortFunction('confirm')">Assigned</th>
                    <th class="header-cell center w5 table-container-th" v-on:click="sortFunction('confirm')">Confirm</th>
                    <th class="header-cell center w5 table-container-th" v-on:click="sortFunction('truckId')">Truck ID</th>
                    <th class="header-cell center w10 table-container-th" v-on:click="sortFunction('driverId')">Container Image</th>
                    <th class="header-cell center w10 table-container-th" v-on:click="sortFunction('driverRemark')">Driver Remark</th>
                    <th v-if="isYI" class="header-cell center w10 table-container-th" v-on:click="sortFunction('pushStatus')">PIN#</th>
                    <th class="header-cell center w10 table-container-th" v-on:click="sortFunction('bolNum')">BOL#</th>
                    <!--<th class="header-cell center w10" v-on:click="sortFunction('pushStatus')">Push Status</th>-->
                    <th class="header-cell center w5 table-container-th" v-on:click="sortFunction('ctnrType')">CTN Type</th>
                    <th class="header-cell center w5 table-container-th" v-on:click="sortFunction('source')">Source</th>
                    <!--<th class="header-cell center w5" v-on:click="sortFunction('ctnrType')">CHZ End Date</th>-->
                    <th class="header-cell center w5 table-container-th" v-on:click="sortFunction('moveInDate')">Move In Date</th>
                    <th class="header-cell center w5 table-container-th" v-on:click="sortFunction('chzStartDate')">Out Gate Date</th>
                    <th class="header-cell center w5 table-container-th" v-on:click="sortFunction('chzEndDate')">In Gate Date</th>
                    <th class="header-cell center w5 table-container-th" v-on:click="sortFunction('ctnrType')">Used Day</th>
                    <th class="header-cell center w5 table-container-th" v-on:click="sortFunction('gwDate')">GW Date</th>
                    <th class="header-cell center w5 table-container-th" v-on:click="sortFunction('loadKey')">Load Key</th>
                    <th class="header-cell center w5 table-container-th" v-on:click="sortFunction('seqNo')">Seq No</th>
                    <th class="header-cell center w10 table-container-th" v-on:click="sortFunction('locationNumber')">Yard Loc.</th>
                    <th class="header-cell center w7 table-container-th" v-on:click="sortFunction('customerOrder')">Cust Order(IBD)</th>
                    <th class="header-cell center w5 table-container-th" v-on:click="sortFunction('sealNumber')">Seal #</th>
                    <th class="header-cell center w5 table-container-th" v-on:click="sortFunction('scaleTicket')">Weight Ticket</th>
                    <th class="header-cell center w5 table-container-th" v-on:click="sortFunction('pickupLoc')">Pickup Loc</th>
                    <th class="header-cell center w10 table-container-th" v-on:click="sortFunction('')">Delivery To</th>
                    <th class="header-cell center w7 table-container-th" v-on:click="sortFunction('pickupTerm')">Pickup Tml</th>
                    <th class="header-cell center w7 table-container-th" v-on:click="sortFunction('dropOffTerm')">Dropoff Tml</th>
                    <th class="header-cell center w5 table-container-th" v-on:click="sortFunction('deliveryOrder')">STC DO</th>
                    <th class="header-cell center w5 table-container-th" v-on:click="sortFunction('stcLoadConfirmedBy')">Confirm By</th>
                    <th class="header-cell center w5 table-container-th" v-on:click="sortFunction('stcLoadConfirmedAt')">Confirm Date</th>
                    <th class="header-cell center w5 table-container-th" v-on:click="sortFunction('stcLoadConfirmedAt')">Confirm Time</th>
                    <th class="header-cell center w5 table-container-th" v-on:click="sortFunction('gwDate')">GW Date</th>
                    <th class="header-cell center w5 table-container-th" v-on:click="sortFunction('doProcess')">DO Process</th>
                    <!--<th class="header-cell center w5" >GST DO Item</th>-->
                    <th class="header-cell center w5 table-container-th" v-on:click="sortFunction('route')">Route #</th>
                    <th class="header-cell center w10 table-container-th" v-on:click="sortFunction('routeDesc')">Route Desc</th>

<!--
                    <th class="header-cell center w5" v-on:click="sortFunction('stage')">Stage #</th>
                    <th class="header-cell center w5" v-on:click="sortFunction('stageType')">IN/OUT</th>
                    <th class="header-cell center w15" v-on:click="sortFunction('pickupLocationCode')">Pickup Location Code</th>
                    <th class="header-cell center w10" >Pickup Location Name</th>
                    <th class="header-cell center w15" v-on:click="sortFunction('deliverLocationCode')">Destionation Code</th>
                    <th class="header-cell center w10" >Destionation Name</th>
                    <th class="header-cell center w10" >Instruction</th>
                    <th class="header-cell center w5" >Cost Relevant</th>
                    <th class="header-cell center w5" >Street Turn</th>
                    <th class="header-cell center w5" >Freight Type</th>
                    <th class="header-cell center w5" v-on:click="sortFunction('chzStartDate')">CHZ start date</th>
                    <th class="header-cell center w5" v-on:click="sortFunction('pickupDate')">Pickup Date</th>
                    <th class="header-cell center w5" >Reference #</th>
                    <th class="header-cell center w8" >Create Person</th>
                    <th class="header-cell center w8" >Create Date</th>
                    <th class="header-cell center w8" >Update Person</th>
                    <th class="header-cell center w8" >Update Date</th>
                    <th class="header-cell center w8" >Grade</th>
                    <th class="header-cell center w8" >Weight</th>
                    <th class="header-cell center w8" >SAP Status</th>
-->                    
                  </tr>
                  </thead>
                </table>
              </div>
              <div class="table-body" @scroll="handleScroll">
                <table id="bodytable">
                  <tbody>
                    <tr :key="item.vueKey" v-for="item in pageItems" 
                          v-bind:class ="{ selected: item.selected }">
                     <td class="body-cell w2 fix">
                      <md-checkbox v-model="item.selected">
                        <!--<span v-if="hasBeenChanged(item)">*</span>-->
                      </md-checkbox>
                    </td>

                    <td class="body-cell excelBox w2">
                        <template v-if="docCutDue >= item.docCut 
                                       && (item.loadStatus == 'ASN' || item.loadStatus == 'OU' || item.loadStatus == 'DIS')"
                        >🛑</template>
                        <!--<template v-if="docCutDue >= item.docCut && item.loadStatus == 'OU'">🛑</template>-->
                        <!--<template v-if="docCutDue >= item.docCut && item.loadStatus == 'DIS'">🛑</template>-->
                    </td> 
                    <td class="body-cell excelBox w5">{{item.salesOffice}}</td>
                    <td class="body-cell excelBox w5">{{item.loadIndicator}}</td>
                    <td class="body-cell excelBox w5">{{item.receivingWindow}}</td>
                    <td class="body-cell excelBox w5" v-on:click="getLoadStatusLog(item)">{{item.loadStatus}}</td>
                    <td class="body-cell excelBox w5">{{item.stageCount}}</td>
                    <!--<td class="body-cell excelBox w5" @click="toggleDispatch(item.seqNo)">{{item.seqNo}}</td>-->
                    <!--
                    <td class="body-cell excelBox w8" @click="togeditHideeContainerCopy(item.containerNo)">{{item.containerNo}}
                      <span v-if="containerCopy == true" class="popuptext" id="myPopup">Container No copied</span></td>
                      
                    <td class="body-cell excelBox w8" @click="toggleContainerCopy(item.chassisNo)"><div class = "spaceLine">{{item.chassisNo}}</div>
                    -->
                     <!-- <div>{{getChassisUsedDate(item.chzStartDate)}} Days</div> -->
                    <!-- 
                      <span v-if="containerCopy == true" class="popuptext" id="myPopup">Chassis No copied</span></td>
                    -->
                    <td  class="body-cell excelBox w8">{{item.containerNo}}</td>
                    <td  class="body-cell excelBox w8">{{item.chassisNo}}</td>
                    <td  class="body-cell excelBox w10">{{item.additionCharge}}</td>
                    <td  class="body-cell excelBox w5">{{item.carrier}}</td>
                    <td  class="body-cell excelBox w5" v-if="chkloadbkcarrier(item)">{{item.loadBookingCarrier}}</td>
                    <td  class="body-cell excelBox w5" v-if="!chkloadbkcarrier(item)" style="color:red">{{item.loadBookingCarrier}}</td>
                    <td  class="body-cell excelBox w5">{{item.grade}}</td>
                    <td  class="body-cell excelBox w5">{{item.loadBookingGrade}}</td>
                    <td  class="body-cell excelBox w5" v-if="item.specGrade == null || item.specGrade == ''">{{item.specGrade}}</td>
                    <td  class="body-cell excelBox w5" v-if="item.specGrade != null && item.specGrade != ''" style="color:red">{{item.specGrade}}</td>
                    <td  v-if="item.mismatchBooking != true" class="body-cell excelBox w10">{{item.bookingNo}}</td>
                    <td  v-if="item.mismatchBooking == true"  class="body-cell excelBox w10 mismatchbk">{{item.bookingNo}}</td>
                    <td  class="body-cell excelBox w10">{{item.emptyPulledBooking}}</td>
                    <td  class="body-cell excelBox w5">
                       <md-checkbox v-model="item.mismatchBooking" disabled></md-checkbox>
                    </td>
                    <td  class="body-cell excelBox w5">{{item.docCut | date}}</td>
                    <!-- <td class="body-cell excelBox w5" v-if="docCutDue >= item.docCut && item.loadStatus = 'LD'" style="background: rgb(243, 67, 67)">{{item.docCut | date}}</td> -->
                    <td  class="body-cell excelBox w5">{{item.cutLFD | date}}</td>
                    <td class="body-cell excelBoxTB w5">
                      <template v-if="disableAppt || needLock(item)">
                        {{item.appointment}}
                      </template>
                      <template v-else>
                       <md-field >
                        <md-input v-model="item.appointment"/>
                      </md-field>
                      </template>
                      
                    </td>
                    <td class="body-cell excelBox w8">
                      <template v-if="disableAppt || needLock(item)">
                        {{showApptDate(item)}}
                      </template>
                      <template v-else>
                        <div style="min-width:160px">
                        <datepicker v-model="item.apptDate">
                      </datepicker>
                        </div>
                      </template>
                      </td>
                      <td class="body-cell excelBox w5">
                      <template v-if="disableAppt || needLock(item)">
                        {{item.apptTime}}
                      </template>
                      <template v-else>
                         <md-field>
                          <md-input v-model="item.apptTime"/>
                        </md-field>
                      </template>
                      </td>
                    <!--<td class="body-cell excelBox w5">{{item.apptDate | time}}</td>-->
                    <td class="body-cell excelBox w10">
                      <template v-if="isSetDriverGroup && chkItemPushStatus(item,'driverGroup') && !needLock(item)">
                          <!--
                          <md-field >
                            <md-input v-model="item.driverGroup"
                            />
                          </md-field>
                          <auto-complete-master-data-select
                                     group="DriverGroup"
                                     :init-value="item.driverGroup"
                                     :on-item-changed="changeDriverGroup(item)"
                          >
                          </auto-complete-master-data-select>
                                                
                          <auto-complete-stc-driver-group-select
                              :options="stcDriverGroupOption"
                              v-model="item.driverGroup"
                        >
                        </auto-complete-stc-driver-group-select>
                      -->
                      <auto-complete-stc-driver-group-select
                              :options="stcDriverGroupOption"
                              :on-item-changed="changeDriverGroupPush(item)"
                              :value="item.driverGroup"
                        >
                        </auto-complete-stc-driver-group-select>
                      </template>
                      <template v-else>
                          {{ item.driverGroup }}
                        </template>
                    </td>
                    <td class="body-cell excelBox w10">
                      <template v-if="isAsgDriver && chkItemPushStatus(item, 'driverId') && !needLock(item)">
                        <auto-complete-select
                                                :options="drivers"
                                                :value="item.driverId"
                                                :on-item-changed="changeAsgDriverId(item)"
                                                >
                        </auto-complete-select>

                      </template>
                        <template v-else>
                          {{ item.driverId }}
                        </template>

                    </td>
                    <td class="body-cell excelBox w5">
                        {{item.pushStatus == 'P' ? 'X' : null}}
                    </td>
                    <td class="body-cell excelBox w5">
                        {{item.pushStatus == 'R' ? 'X' : null}}
                    </td>
                    <template v-if="needLock(item)">
                      <td class="body-cell excelBox w5">
                        {{item.pushStatus == 'REJ' ? 'X' : null}}
                      </td>
                    </template>
                    <template v-else>
                      <td class="body-cell excelBox w5" @click.prevent="checkPushStatus(item,'REJ')">
                        {{item.pushStatus == 'REJ' ? 'X' : null}}
                      </td>
                    </template>
                    <td class="body-cell excelBox w5">
                        {{item.pushStatus == 'A' ? 'X' : null}}
                    </td>
                    <template v-if="needLock(item)">
                       <td class="body-cell excelBox w5">
                          {{item.pushStatus == 'C' ? 'X' : null}}
                       </td>
                    </template>
                    <template v-else>
                       <td class="body-cell excelBox w5" @click.prevent="checkPushStatus(item,'C')">
                          {{item.pushStatus == 'C' ? 'X' : null}}
                       </td>
                    </template>
                    <td class="body-cell excelBox w5">{{item.truckId}}</td>
                    <!--<td class="body-cell excelBox w10">{{item.driverCntrImg}}</td>-->
                    <td class="body-cell excelBox w10">
                        <template v-if="item.driverCntrImg != null">
                          <!--<a href="" @click.prevent="toggleItemLink(item)">-->
                            <!--<a href="" @click.prevent="testpop(item)">-->
                          <a href="" @click.prevent="toggleItemLink1(item)" target="_blank" rel="noopener">      
                            1 image
                            </a>
                        </template>  
                        <template v-else>
                            0 image
                        </template>  
                    </td>
                    <td class="body-cell excelBox w10">
                      <template v-if="item.driverRemark != null">
                         <a href="" @click.prevent="showRemark(item.driverRemark)" target="_blank" rel="noopener">
                           remark 
                        </a>
                      </template>
                      <template v-else>

                      </template>
                    </td>
                    <td v-if="isYI" class="body-cell excelBox w10">{{item.pinNum}}</td>
                    <td class="body-cell excelBox w10">{{item.bolNum}}</td>
                    <!--
                    <td class="body-cell excelBox w10">
                        <template v-if="isConfirm">
                          <auto-complete-master-data-select
                              group="PUSH_STATUS"
                              :init-value="item.pushStatus"
                              :on-item-changed="handleItemPushStatusChanged(item)"
               >
               </auto-complete-master-data-select>
                        </template>                      
                        <template v-else>
                           {{getPushStatusInfo(item.pushStatus)}}
                        </template>
                    </td>
                  -->
                    <td  class="body-cell excelBox w5">{{item.ctnrType}}</td>
                    <td  class="body-cell excelBox w5">{{item.source}}</td>
                    <!--<td  class="body-cell excelBox w5">{{item.chzEndDate}}</td>-->
                    <td  class="body-cell excelBox w5">{{item.moveInDate}}</td>
                    <td  class="body-cell excelBox w5">{{item.chzStartDate}}</td>
                    <td  class="body-cell excelBox w5">{{item.chzEndDate}}</td>
                    <td  class="body-cell excelBox w5" v-if="!overPeriod(item)">{{item.ctnrUsedDay}} Days</td>
                    <td  class="body-cell excelBox w5" v-if="overPeriod(item)" style="color:red">{{item.ctnrUsedDay}} Days</td>
                    <td  class="body-cell excelBox w5">{{item.gwDate}}</td>
                    <td  class="body-cell excelBox w5">
                      <!--
                      <a href="" @click.prevent="doSingleDispatch(item)">{{item.loadKey}}</a>
                      -->
                      {{item.loadKey}}
                    </td>
                    <td  class="body-cell excelBox w5">{{item.seqNo}}</td>
                    <td  class="body-cell excelBox w10"><div class = "spaceLine">{{item.yard}} {{item.locationNumber}}</div></td>
                    <td  class="body-cell excelBox w7">{{item.customerOrder}}</td>
                    <td  class="body-cell excelBox w5">{{item.sealNumber}}</td>
                    <td  class="body-cell excelBox w5">{{item.scaleTicket}}</td>
                    <td  class="body-cell excelBox w5">
                      <master-data-display group="GST_LOCATION" :tag-id="item.pickupLoc"/>
                    </td>
                    <td class="body-cell excelBox w10">
                        <master-data-display group="GST_LOCATION" :tag-id="item.deliveryTo"/>
                    </td>
                    <td class="body-cell excelBox w7">
                        <master-data-display group="GST_TERMINAL" :tag-id="item.pickupTerm"/>
                    </td>
                    <td class="body-cell excelBox w7">
                        <master-data-display group="GST_TERMINAL" :tag-id="item.dropOffTerm"/>
                        <!--{{item.containerDropOffLocation}}-->
                    </td>
                    <td class="body-cell excelBox w5">{{item.deliveryOrder}}</td>
                    <td class="body-cell excelBox w5">{{item.stcLoadConfirmedBy}}</td>
                    <td class="body-cell excelBox w5">{{item.stcLoadConfirmedAt | date}}</td>
                    <td class="body-cell excelBox w5">{{item.stcLoadConfirmedAt | time}}</td>
                    <td class="body-cell excelBox w5">{{item.gwDate | date}}</td>
                    <td class="body-cell excelBox w5">{{item.doProcess}}</td>
                    <!--<td class="body-cell excelBox w5">{{item.deliveryOrderItem}}</td>-->
                    <td class="body-cell excelBox w5"> {{item.route}}</td>
                     <td class="body-cell excelBox w10"> {{item.routeDesc}}</td>



<!--
                    <td  class="body-cell excelBox w5">{{item.stage}}</td>
                    <td  class="body-cell excelBox w5">{{item.stageType}}</td>
-->                    
                    <!-- <td  class="body-cell excelBox w5">{{item.pickupLoc}}</td>
                    <td  class="body-cell excelBox w5">{{item.deliveryTo}}</td> -->
<!--                    
                    <td class="body-cell excelBox w15">
                      <autocomplete-ccic-location-select
                          v-if="item.editing"
                          v-model="item.pickupLocationCode"
                          group="GST_LOCATION"
                          :on-item-selected="handlePickLocationChanged(item)"
                      />
                      <template v-else>{{item.pickupLocationCode}}</template>
                      </td>
                      <td class="body-cell excelBox w10">
                        <master-data-display group="GST_LOCATION" :tag-id="item.pickupLocationCode"/>
                      </td>
                    <td class="body-cell excelBox w15">
                      <autocomplete-ccic-location-select
                          v-if="item.editing"
                          v-model="item.deliverLocationCode"
                          group="GST_LOCATION"
                          :on-item-selected="handleDeliverLocationChanged(item)"
                      />
                      <template v-else>{{item.deliverLocationCode}}</template></td>
                      <td class="body-cell excelBox w10">
                        <master-data-display group="GST_LOCATION" :tag-id="item.deliverLocationCode"/>
                      </td>
                    <td class="body-cell excelBox w10" @click="toggleInstruction(item)">
                        {{item.dispatcherInstruction}}
             
                      
                      </td>
                    <td class="body-cell excelBox w5">
                      <template v-if="!item.editing">
                        {{item.costRelevant}}
                      </template>
                      <template v-else>
                       <md-field >
                        <md-input v-model="item.costRelevant"/>
                      </md-field>
                      </template>
                      
                      </td>
                    <td class="body-cell excelBox w5">{{item.source}}</td>
                    <td class="body-cell excelBox w5">
                      <template v-if="!item.editing">
                        {{item.freightType}}
                      </template>
                      <template v-else>
                       <md-field >
                        <md-input v-model="item.freightType"/>
                      </md-field>
                      </template>
                      
                      </td>
                    <td class="body-cell excelBox w5">{{item.chzStartDate | date}}</td>
                    <td class="body-cell excelBox w5">{{item.pickupDate | date}}</td>
                    <td class="body-cell excelBox w5">{{item.customerRef}}</td>
                     <td class="body-cell excelBox w8">{{item.createdBy}}</td>
                    <td class="body-cell excelBox w8">{{item.createdAt | date}}</td>
                    <td class="body-cell excelBox w8">{{item.updatedBy}}</td>
                    <td class="body-cell excelBox w8">{{item.updatedAt | date}}</td>
                    <td class="body-cell excelBox w8">{{item.grade}}</td>
                    <td class="body-cell excelBox w8">
                       <template v-if="item.weight != 'null'">
                          {{item.weight}}
                       </template>
                    </td>
                    <td class="body-cell excelBox w8">{{item.sapStatus}}</td>
--> 
                   </tr>
 
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </md-card>
      </template>
    </pagination>
    <!--<div class="dropdown">-->
        <!---<md-button :disabled="!this.getPermission.stcClerk.view" class="md-raised custButton " @click="doDropDown">...  <span class="icons-center material-icons">add</span></md-button>-->
        <div id="dropdown" class="dropdown-content" v-if="showDropDown">
            <template v-if="disableAppt == false">
               <a href="#" id="dd_li" @click="editAppt" disabled="!canEdit" style="color:red;">Appointment</a>
            </template>
            <template v-else>
               <a href="#" id="dd_li" @click="editAppt" disabled="!canEdit">Appointment</a>
            </template>
            <!--<a href="#" id="dd_li" @click="editAppt" disabled="!canEdit">Appointment</a>-->
            <template v-if="isSetDriverGroup == true">
               <a href="#" @click="editDriverGroup" style="color:red;">Driver Group</a>  
            </template>
            <template v-else>
               <a href="#" @click="editDriverGroup">Driver Group</a>  
            </template>
            <!--<a href="#" @click="editDriverGroup">Driver Group</a>-->
            <template v-if="isAsgDriver == true">
               <a href="#" @click="doAsgDriver" style="color:red;">Assign Driver</a>  
            </template>
            <template v-else>
               <a href="#" @click="doAsgDriver">Assign Driver</a>  
            </template>
            <!--<a href="#" @click="doAsgDriver">Assign Driver</a>-->
            <a href="#" v-if="this.getPermission.stcMgt.edit || this.getPermission.acnit.edit || getPermission.stcWithPM.edit" @click="doAdditionCharge">Add Addition Charge</a>
        </div> 
    <!--</div>-->
  </div>





</template>


<style scoped>
.popup {
  position: relative;
  display: inline-block;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.spaceLine {
  margin-bottom: 10px;
}
.popuptext {
  visibility: show;
  width: 160px;
  background-color: #555;
  color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 8px 0;
  position: absolute;
  z-index: 10;
  bottom: 125%;
  left: 50%;
  margin-left: -80px;
}
.excelBox {
    padding-top: 5px;
    padding-bottom: 5px;
    padding-left: 5px;
    padding-right: 5px;
    text-align: center;
}
.excelBoxTB {
    padding-top: 5px;
    padding-bottom: 5px;
    padding-left: 5px;
    padding-right: 5px;
    text-align: center;
    margin-right: 5px;
  
}
.excelBoxLeft {
    padding-top: 5px;
    padding-bottom: 5px;
    padding-left: 5px;
    padding-right: 5px;
}
.material-icons.md-18 { font-size: 18px; }
.material-icons.md-24 { font-size: 24px; }
.material-icons.md-36 { font-size: 36px; }
.material-icons.md-48 { font-size: 100px; }
.material-icons.md-light { color: rgba(255, 255, 255, 1); }
.material-icons.md-light.md-inactive { color: rgba(255, 255, 255, 0.3); }
.icons-center {
    vertical-align: middle;
    margin-right: 10px;
}
.inputBox {
    border: 1px solid #cacbcc;
    border-radius: 5px;
    color: #29303b;
    font-size: 18px;
    height: auto;
    line-height: 1em;
    padding: 5px 5px 5px 5px;
    margin-top: 6px;
}
.inputBox:hover {
  
    border: 2px solid #448aff;
    border-radius: 5px;
    color: #29303b;
    font-size: 18px;
    height: auto;
    line-height: 1em;
    padding: 5px 5px 5px 5px;
    margin-top: 6px;
    background-color: #e0eff7;
      
}
.selected {
     background: #c8e6f5;
}
.tableW {
    height: 40px;
}
.center {
    text-align: center;
}

tr:hover {
    background: #c8e6f5;
}

.headerCenter {
    text-align: center;
}
.modal {
     background-color: #29303b;
      border-radius: 5px;
}
.modalTitle {
    font-weight: normal;
    font-family: 'UberMove', 'Open Sans', 'Helvetica Neue', Helvetica, sans-serif !important;
    font-weight: 500;
    color: white;
    font-family: Poppins, sans-serif;
    margin-bottom: 0.5rem;
    line-height: 1.6;
}
.md-menu {
  padding: 0;
  padding: 0;

}
.custButton {
    margin: 5px;
    width: 90px;
    height: 36px;
    line-height:20px;
    font-size: 0.8rem;
}
.custMedButton {
    margin: 5px;
    width: 110px;
    height: 36px;
    line-height:20px;
    font-size: 0.8rem;
}
.custMenuButton {
    
    width: 110px;
    height: 40px;
    line-height:45px;
    font-size: 0.9rem;
    align-self: center;
}
.custSearchBar{
    margin: 5px;
    width: 200px;
    height: 40px;
    line-height:40px;
    font-size: 0.9rem;
}
.custButtonRight {
    margin: 10px;
    width: 100px;
    height: 40px;
    float : right;
}
.result-included-inner-div-radio {
    margin-left: 5px;
    margin-bottom: -25px;
    margin: -12px;
}
.result-included-span-radio {
    font-weight: bold;
    margin-left: 12px;
    margin-right: 12px;
    position:relative;
    top: -5px;
}
.result-included-outter-div {
    border: 1px solid #D0D0D0;
    border-radius: 5px;
    width: 600px;
    padding: 10px;
    height: 43px;
    margin-top: 5px;
    margin-bottom: 5px;
    margin-left: 20px;
}

.dropbtn {
  background-color: #3498DB;
  color: white;
  padding: 16px;
  font-size: 16px;
  border: none;
  cursor: pointer;
}

/* Dropdown button on hover & focus */
.dropbtn:hover, .dropbtn:focus {
  background-color: #2980B9;
}

/* The container <div> - needed to position the dropdown content */
.dropdown {
  position: relative;
  display: inline-block;
}

/* Dropdown Content (Hidden by Default) */
.dropdown-content {
  /*display: none;*/
  position: absolute;
  /*position: relative;*/
  /*position: fixed;*/
  background-color: #f1f1f1;
  min-width: 160px;
  box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);
  /*z-index: -1;*/
  margin-top: -50px;
  margin-left: 280px;
  z-index: 300;
}

/* Links inside the dropdown */
.dropdown-content a {
  color: black;
  padding: 12px 16px;
  text-decoration: none;
  display: block;
}

/* Change color of dropdown links on hover */
.dropdown-content a:hover {background-color: #ddd;}

/* Show the dropdown menu (use JS to add this class to the .dropdown-content container when the user clicks on the dropdown button) */
.show {display:block;}
.setzindex {z-index:3;}
.mismatchbk { color: red; }

.bg-col {
  background-color: rgb(194, 228, 181);
  color: rgb(185, 121, 121);
  border-right: solid 3px rgba(119, 115, 115, 0.918);
  border-bottom: solid 3px rgba(119, 115, 115, 0.918);
}
.bgye {
  color: rgb(83, 83, 146);
  font-weight:bold;
}
.bgye:hover {
  color: rgb(53, 53, 122);
}
.bge {
  color: rgb(87, 87, 146);
  font-weight:bold;
}
.bgi {
  color: rgb(87, 87, 146);
  font-weight:bold;
}
.bgtl {
  color: rgb(87, 87, 146);
  font-weight:bold;
}
.bgtype {
  color: rgb(100, 32, 32);
}
.gapupper {
  margin-top: 55px;
}
.fix {
  left: 0;
  position: -webkit-sticky;
  position: sticky;
  background: white;
  /*background-color: #5b69aa;*/
}
.table-container {
    background-color: #5b69aa;
}
.table-container-th {
    color: white !important;
    padding-top: 3px;
}
.selected {
     background: yellow;
}
</style>



<script>
  /* eslint-disable no-plusplus */
  import { mapGetters } from 'vuex';
  import dateFormat from '../utils/dateFormat';
  import toGenerateExcelRequest, { downloadExcel } from "../utils/excel";
  //import api from "../api";
  import { newAPIPost } from '../api/index.js';
  import UpdateCcicContainerStatusForm from "../components/UpdateCcicContainerStatusForm.vue";
  import CcicPhotoForm from "../components/CcicPhotoForm.vue";
  import MoveCcicContainerForm from "../components/MoveCcicContainerForm.vue";
  import parseXls from "../utils/parseXls";
  import callingApiCenter from "../components/CallingApiCenter.vue";
  import YardExportForm from '../components/YardExportForm.vue';
  import DispatchForm from '../components/DispatchForm.vue';
  import AutocompleteCcicLocationSelect from "../components/AutocompleteCcicLocationSelect.vue";
  import AutoCompleteStcDriverGroupSelect from '../components/AutoCompleteStcDriverGroupSelect.vue';
  import OutboundBooking from '../components/OutboundBooking.vue';
  import UpdateDriverGroupForm from '../components/UpdateDriverGroupForm.vue';
  import { IoTJobsDataPlane } from '@aws-sdk/client-iot-jobs-data-plane';
  import UpdateStcContainerStatusForm from "../components/UpdateStcContainerStatusForm.vue"
  import LoadStatusLog from "../components/LoadStatusLog.vue"

const initSearchCriteria = () => ({
    receivingWindow: null,
    salesOffice: null,
    pickupLocation: null,
    bookingNo: null,
    destination: null,
    appointment: null,
    driverId: null,
    driverGroup: null,
    costRelevant: null,
    freightType: null,
    cargoCutOff: {
      startDate: null,
      endDate: null,
    },
    apptDate: {
      startDate: null,
      endDate: null,
    },
    moveInDate: {
      startDate: null,
      endDate: null,
    },
    inGateDate: {
      startDate: null,
      endDate: null,
    },
    loadKey: null,
    source: null,
    containerNo: null,
    chassisNo: null,
    ctnrType: null,
    carrier: null,
    customerOrder: null,
    deliveryOrder: null,
    loadStatus: [],
    pushStatus: null,
    stageType: null,
    filter: null,
    fromPage: null,
    selectDType: null
 
})

const getInitSearch = () => ({
    users: [],
    teams: [],
    receivingWindow: null,
    salesOffice: null,
    pickupLocation: null,
    bookingNo: null,
    destination: null,
    appointment: null,
    driverId: null,
    driverGroup: null,
    costRelevant: null,
    freightType: null,
    // chzStartDate: {
    //   startDate: null,
    //   endDate: null,
    // },

    cargoCutOff: {
      startDate: null,
      endDate: null,
    },
    apptDate: {
      startDate: null,
      endDate: null,
    },
    moveInDate: {
      startDate: null,
      endDate: null,
    },
    inGateDate: {
      startDate: null,
      endDate: null,
    },
    // pickupDate: {
    //   startDate: null,
    //   endDate: null,
    // },


    loadKey: null,
    source: null,
    containerNo: null,
    chassisNo: null,
    carrier: null,
    //yard: null,
    //locationNumber: null,
    customerOrder: null,
    deliveryOrder: null,
    //route: null,
    //locCode:null,
    //group:null,
    //locName: null,
    loadStatus: ['LD', 'ASN'],
    //selected: false,
    pushStatus: null,
    stageType: null
  })

  const initCockpitReq = () => ({
     mode: null,
     carrierName: null,
     customerOrder: null,
     route: null,
     deliveryOrder: null,
     loadKey: null,
     bookingNo: null
  })

  const initSearchDriverGroup = () => ({
     seqNo: null,
     driverGroup: null,
     userName: null,
     driverId: null,
     active: true,
     driverName: null,
     recWindow: null
  })

  const initAgreementHeader = () => ({
     salesOffice: null,
     adesc: null,
     validFrom: null,
     validTo: null,
     signedBy: null,
     departureCode: null,
     destinationCode: null,
     commodity: null,
     freeDay: null,
     ctnType: null,
     orderType: null,
     currency: null,
     allInRate: null,
     paymentTerm: null,
     payer: null,
     extendedBy: null 
  })

  const initDummyLoad = () => ({
     loadStatus: null,
     receivingWindow: null,
     loadKey: null,
     containerNo: null,
     ctnrType: null,
     chassisNo: null,
     sealNumber: null,
     chzStartDate: null,
     chzEndDate: null,
     cutLFD: null,
     grade: null,
     deliveryOrder: null,
     bookingNo: null,
     carrier: null,
     loadBookingGrade: null,
     customerOrder: null,
     ctnrDropOff: null,
     appointment: null,
     apptDate: null,
     apptTime: null,
     custId: null,
     driverGroup: null,
     driverId: null,
     pushStatus: null,
     truckId: null,
     dispatcher: null,
     specGrade: null,
     driverRemark: null,
     mode: null,
     handler: null
  })

  const getInitDriverSearch = () => ({
     source: null,
     driverOffice: null,
     defaultSalesOffice: null,
     onlyActive: "X"
  })

  const getInitAgreementSearch = () => ({
     salesOffice: null,
     agreement: null,
     rateType: null,
     validOn: null,
     payer: null,
     departureCode: null,
     destinationCode: null,
     selected: false
  })

  export default {

    data: () => ({
      searchRequest: getInitSearch(),
      cockpitRequest: initCockpitReq(),
      searchCriteria: initSearchCriteria(),
      searchDriverGroupReq: initSearchDriverGroup(),
      searchDriverSearchReq: getInitDriverSearch(),
      agreementSearchRequest: getInitAgreementSearch(),
      agreementHeaderInfo: initAgreementHeader(),
      active: false,
      drivers: [],
      items: [],
      selectedItems: [],
      dialog: {
        isShowing: false,
      },
      cutoffdate: {
        startDate: null,
        endDate: null
      },
      usersToSearch: [],
      modalMessage: "",  
      isWarning: false,
      active: false,
      sortStatus: true,
      filter: "",
      containerCopy: false,
      selectAll: false,
      notifyMessage: null,
      notifyActive: false,
      selectDType: "YE",
      isPictureModalShowing: false,
      photoZipFileName: '',
      filePrefixForEachFile: '',
      isLoading: false,
      isdownloadzip: false,
      imgPath: null,
      photoTitle: "Photos",
      photos: [],
      singleReq: [],
      isSetDriverGroup: false,
      isSetAppointment: false,
      isAsgDriver: false,
      isSetPIN: false,
      isConfirm: false,
      isYI: false,
      disableSave: false,
      disableAppt: true,
      driverGroups: [],
      stcDriverGroups: [],
      stcDriverGroupOption: [],
      driverIds: [],
      driverNames: [],
      driverContent: [],
      agreementItems: [],
      showDropDown: false,
      disableupdateloadstatus: true,
      bobtailOnly: false,
      docCutDue: dateFormat.getLocalDate(moment(moment().add(2,'days').startOf('d').toDate())),
    }),


    components: {
      AutocompleteCcicLocationSelect,
      AutoCompleteStcDriverGroupSelect,
      MoveCcicContainerForm,
      UpdateCcicContainerStatusForm,
      CcicPhotoForm,
      callingApiCenter,
      YardExportForm,
      DispatchForm,
      OutboundBooking,
      UpdateDriverGroupForm,
      UpdateStcContainerStatusForm,
      LoadStatusLog,
    },

    watch: {
      getYardExportList(val) {
        this.updateItems(val);
      },
      getDirectExportList(val) {
        this.updateItems(val);
      },
      getTruckLoadList(val) {
        this.updateItems(val);
      },
      getImportLoadList(val) {
        this.updateItems(val);
      },
      getSTCDriverGroup(val) {
        this.updateDriverGroupItems(val);
      },

      // eslint-disable-next-line
      "searchRequest.teams"() {
         this.searchRequest.users = [];
      },
      notifyActive(val) {
        if (val == false)
        {
          this.notifyMessage = null;
        }
      },
      // getDriverFromId(id) {
      //   this.getDriverFromId(id);
      // }
    },

    computed: {
    ...mapGetters([
        'getMasterDataName',
        'getMasterDataByGroup',
        'getMasterDataAsSelectOptionByGroup',
        'getPermission',
        'getUserProfile',
        'getRole',
        'getYardExportList',
        'getImportLoadList',
        'getTruckLoadList',
        'getDirectExportList',
        'getSTCDriverGroup',
        'getGSTDriverMaster',
      ]),


      filteredRows(){
        if (this.filter == null) this.filter = "";
        var items = [];
        if (this.bobtailOnly == true)
        {
            console.log(`this items: ${JSON.stringify(this.items)}`);
            items = this.items.filter( it => it.bobtailContainer == true);
        } else {
            items = this.items; 
        }
        if (items && items.length > 0) {
           return items.filter(row => {
              const term = this.filter.toUpperCase();
              return this.includeNull(row.containerNo).includes(term) ||
                     this.includeNull(row.chassisNo).includes(term) ||
                     //  this.includeNull(row.loadKey).includes(term)||
                     this.includeNull(row.seqNo).includes(term)||
                     this.includeNull(row.loadStatus).includes(term)||
                     this.includeNull(row.stageStatus).includes(term)||
                     this.includeNull(row.stageType).includes(term)||
                     this.includeNull(row.bookingNo).includes(term)||
                     this.includeNull(row.sealNumber).includes(term)||
                     this.includeNull(row.specGrade).includes(term);
            })
        } else { return [];}
        // if (this.items && this.items.length > 0) {
        //    return this.items.filter(row => {
        //       const term = this.filter.toUpperCase();
        //       return this.includeNull(row.containerNo).includes(term) ||
        //              this.includeNull(row.chassisNo).includes(term) ||
        //              //  this.includeNull(row.loadKey).includes(term)||
        //              this.includeNull(row.seqNo).includes(term)||
        //              this.includeNull(row.loadStatus).includes(term)||
        //              this.includeNull(row.stageStatus).includes(term)||
        //              this.includeNull(row.stageType).includes(term)||
        //              this.includeNull(row.bookingNo).includes(term)||
        //              this.includeNull(row.sealNumber).includes(term)||
        //              this.includeNull(row.specGrade).includes(term);
        //     })
        // } else { return [];}
      },



      getSelectedItems() {
        return _(this.items)
          .filter(it => it.selected);
      },

      getEditingItems() {
        return _(this.items)
          .filter(it => it.editing);
      },


      getAssignBookingCond() {

        // const items = _(this.items).filter((it) => it.selected);
        // const LD = _(this.items).filter((it) => it.loadStatus == 'ASN');
        // if (LD.length != 0) return false;
        // const weighted = _(items).filter((it) => it.weight != 'null');
        // if (items.length == 0) return false
        // const ctnrType = [...new Set(items.map(s => s.ctnrType))];
        // const grade = [...new Set(items.map(s => s.grade))];
        // const carrier = [...new Set(items.map(s => s.carrier))];
        // // carrier.length === 1
        // const sapStatus = _(this.items).filter((it) => it.sapStatus != 'X');
        // if (sapStatus.length == 0) return false
        // console.log("grade: " + grade + " grade length: " + grade.length + ":" + this.isValidCond(grade) + " ctnrType: " + ctnrType + "ctnrType length: " + ctnrType.length + ":" + this.isValidCond(ctnrType) + " weight: " + weighted + ":" + weighted.length);
        // //return items.length === weighted.length && ctnrType.length === 1 && grade.length === 1
        // return items.length === weighted.length && this.isValidCond(ctnrType) && this.isValidCond(grade);
        const items = _(this.items).filter((it) => it.selected);
        //const LD = _(this.items).filter((it) => it.loadStatus == 'ASN');
        const LD = items.filter((it) => it.loadStatus == 'ASN');
        if (LD.length != 0) return false;
        const weighted = _(items).filter((it) => it.weight != null);
        const DO = items.filter((it) => it.deliveryOrder != null);
        const BLC = items.filter((it) => it.loadStatus == 'BLC');
        const CFM = items.filter((it) => it.loadStatus == 'CFM');
        const LOK = items.filter((it) => it.loadStatus == 'LOK');
        if (BLC.length != 0) return false;
        if (CFM.length != 0) return false;
        if (LOK.length != 0) return false;
        if (DO.length != 0) return false;
        if (items.length == 0) return false
        
        const ctnrType = [...new Set(items.map(s => s.ctnrType))];
        const grade = [...new Set(items.map(s => s.grade))];
        const carrier = [...new Set(items.map(s => s.carrier))];
        // carrier.length === 1
        const sapStatus = _(this.items).filter((it) => it.sapStatus != 'X');
        if (sapStatus.length == 0) return false
        //console.log("grade: " + grade + ":" + grade.length + " ctnrType: " + ctnrType + ":" + ctnrType.length);
        return items.length === weighted.length && ctnrType.length === 1 && grade.length === 1

      },

      getUnAssignBookingCond() { 
         //console.log("unassign cond");
         const item = _(this.items).filter((it) => it.selected);
         const sapStatus = _(this.items).filter((it) => it.sapStatus != 'X');
         if (sapStatus.length == 0) return false
         const BLC = item.filter((it) => it.loadStatus == 'BLC');
         const CFM = item.filter((it) => it.loadStatus == 'CFM');
         const LOK = item.filter((it) => it.loadStatus == 'LOK');
         //console.log("unassign item length:" + item.length);
         if (BLC.length != 0) return false;
         if (CFM.length != 0) return false;
         if (LOK.length != 0) return false;
         return item.length === 1 && item[0].loadStatus == 'ASN'
      },
  
      getSelectedItems() {
        return _(this.items).filter((it) => it.selected);
      },


      canOutGate(){
        return this.getSelectedItems.length != 0
      },


      canEditSingle() {
         return this.getSelectedItems.length === 1 ;
        
         //return this.getSelectedItems.length === 1 ;
      },

      canEditSingle() {
         return this.getSelectedItems.length === 1 ;
        
         //return this.getSelectedItems.length === 1 ;
      },


      canEdit() {
        return this.getSelectedItems.length != 0 ;
      },


      canSave() {
        //console.log("canSave: " + this.disableSave);
        return this.disableSave;
      },

      canDoPIN() {
        //console.log("canDoPIN: " + this.isYI);
        return !this.isYI;
      },

      noGates(){
          if (this.getSelectedItems.length == 0)
          {
            return false
          }
          var gates = false
          this.getSelectedItems.forEach((it) => {
            if (it.loadKeyWithStageNo == null)
            {
              gates = true
            }
          });
          return !gates;
      },

      // canSave() {
      //   return !!_(this.getEditingItems)
      //     .find(it => !!this.hasBeenChanged(it));
      // },


      canDelete(){

        
        if (this.getSelectedItems.length != 1)
        {
          return false
        }

        if (this.getSelectedItems[0].stageStatus != null)
        {
          return false
        }

        return true


      },

      canDeleteBooking() {
        if (this.getSelectedItems.length != 1)
        {
          return false
        }

        if (this.getSelectedItems[0].deliveryOrder == null)
        {
          return false
        }

        return true
      },


      canDeleteLoad(){

        
        if (this.getSelectedItems.length != 1)
        {
          return false
        }

        if (this.getSelectedItems[0].stageStatus != null)
        {
          return false
        }

        if (this.getSelectedItems[0].loadStatus != "JO")
        {
          return false
        }

        return true


      },

      getDownloadCond() {
          const item = _(this.items).filter((it) => it.selected);
          if (item.length == 0 && this.items.length != 0) return this.items;

      },

      getSTCDrivers() {
          return this.getGSTDriverMaster;
      },


    },

    async mounted() {
      
      this.drivers = [];
      //console.log("location")
      //console.log(this.getMasterDataAsSelectOptionByGroup('GST_LOCATION'))
      // this.$store.dispatch('getUsersByCategory', { category: 'L' })
      //   .then((res) => {
      //     this.drivers = res;
  
      //   });
      //this.searchRequest = this.getInitSearch();
      this.searchDriverSearchReq.driverOffice = "STC";
      this.searchDriverSearchReq.defaultSalesOffice = "LGB";
      this.searchDriverSearchReq.onlyActive = true;
      this.$store.dispatch('gstDriverMaster', this.searchDriverSearchReq);
        //await this.updateDrivers(this.getGSTDriverMaster); 
        this.updateDrivers(this.getGSTDriverMaster); 
        //console.log("driver from getter: " + this.driverNames);
        this.searchRequest.salesOffice = this.getUserProfile.driverGroup;
        //default move in date for 3 months back date from today
        this.searchRequest.moveInDate.endDate = this.getDateDiffForDatePicker(Date(),0);
        this.searchRequest.moveInDate.startDate = this.getDateDiffForDatePicker(Date(), 31);
        this.$nextTick(() => { 
          if (this.$el && this.$el.querySelector && this.$el.querySelector('#expand-button'))
          {
             console.log('el ', this.$el);
             if (this.$el.querySelector('#expand-button'))
                this.$el.querySelector('#expand-button').click();
          }
        });
        const cachedSearchRequest = this.$store.state.yardExportList.searchRequest;
        // if (cachedSearchRequest) {
        //  this.searchRequest = JSON.parse(JSON.stringify(cachedSearchRequest));
        // }
        //if (this.$route.name != null)
        //   console.log("router name: " + this.$route.name);
        if (this.$route.params != null) {
           if (this.$route.params.req != null) {
              //console.log("dispatchload: router params: " + this.$route.params.req);
              var searchCriteria = JSON.parse(this.$route.params.req);
              //console.log("fallback searchCriteria: " + searchCriteria + ", containerNo: " + searchCriteria.containerNo);
              //console.log("fallback containerNo: " + this.$route.params.req.containerNo);
              console.log("searchCriteria: " + JSON.stringify(searchCriteria));
              this.searchRequest.containerNo = searchCriteria.containerNo;
              this.handleWindowsChanged(searchCriteria.receivingWindow);
              this.searchRequest.salesOffice = searchCriteria.salesOffice;
              this.searchRequest.pickupLocation = searchCriteria.pickupLocation;
              this.searchRequest.bookingNo = searchCriteria.bookingNo;
              this.searchRequest.destination = searchCriteria.destination;
              this.searchRequest.appointment = searchCriteria.appointment;
              this.searchRequest.driverId = searchCriteria.driverId;
              this.searchRequest.driverGroup = searchCriteria.driverGroup;
              this.searchRequest.costRelevant = searchCriteria.costRelevant;
              this.searchRequest.freightType = searchCriteria.freightType;
              this.searchRequest.cargoCutOff.startDate = searchCriteria.cargoCutOff.startDate;
              this.searchRequest.cargoCutOff.endDate = searchCriteria.cargoCutOff.endDate;
              this.searchRequest.apptDate.startDate = searchCriteria.apptDate.startDate;
              this.searchRequest.apptDate.endDate = searchCriteria.apptDate.endDate;
              this.searchRequest.loadKey = searchCriteria.loadKey;
              this.searchRequest.source = searchCriteria.source;
              this.searchRequest.chassisNo = searchCriteria.chassisNo;
              this.searchRequest.carrier = searchCriteria.carrier;
              this.searchRequest.customerOrder = searchCriteria.customerOrder;
              this.searchRequest.deliveryOrder = searchCriteria.deliveryOrder;
              this.searchRequest.loadStatus = searchCriteria.loadStatus;
              this.handlePushStatusChanged(searchCriteria.pushStatus);
              this.searchRequest.stageType = searchCriteria.stageType;
              this.searchRequest.moveInDate.startDate = searchCriteria.moveInDate.startDate;
              this.searchRequest.moveInDate.endDate = searchCriteria.moveInDate.endDate;
              this.searchRequest.inGateDate.startDate = searchCriteria.inGateDate.startDate;
              this.searchRequest.inGateDate.endDate = searchCriteria.inGateDate.endDate;
              this.filter = searchCriteria.filter;
              this.selectDType = searchCriteria.selectDType;
              //this.searchRequest.containerNo = "NYKU5163735";
           }   
           //else
           //   console.log("no router req info");   
        }   
        //else
        //   console.log("no router params info");
        if (!this.selectDType) this.selectDType = "YE";
        if (( !this.searchRequest.loadStatus || this.searchRequest.loadStatus == "") 
            && (this.searchRequest.moveInDate.endDate == "") && (this.searchRequest.moveInDate.startDate == "")) {
              this.searchRequest.moveInDate.endDate = this.getDateDiffForDatePicker(Date(),0);
              this.searchRequest.moveInDate.startDate = this.getDateDiffForDatePicker(Date(), 31); 
        }
        if (!this.searchRequest.cargoCutOff) {
           this.searchRequest.cargoCutOff.startDate = "";
           this.searchRequest.cargoCutOff.endDate = "";
        }

        //if (!this.searchRequest.loadStatus || this.searchRequest.loadStatus == "") this.searchRequest.loadStatus = ['ASN','LD'];
        console.log("loadStatus: " + this.searchRequest.loadStatus); 
        this.$nextTick(() => { 
          if (this.$el && this.$el.querySelector)
          { 
            if (this.$el.querySelector('#searchTag'))
               this.$el.querySelector('#searchTag').click();
          }
        });
        console.log("select D type: " + this.selectDType);
        if (this.selectDType == "YE") {
            //console.log("YardExportList");
            this.searchRequest.type = "";
            this.updateItems(this.getYardExportList);
        }
        else if (this.selectDType == "I") {
            //console.log("ImportLoadList");
            this.searchRequest.type = "YI";
            this.updateItems(this.getImportLoadList);
        }
        else if (this.selectDType == "E") {
            //console.log("DirectExportList");
            this.searchRequest.type = "YE";
            this.updateItems(this.getDirectExportList);
        }  
        else if (this.selectDType == "TL") {
            //console.log("TruckLoadList");
            this.searchRequest.type = "YT";
            this.updateItems(this.getTruckLoadList);  
        }  
        // switch (this.selectDType) {
        //   default: 
        //     console.log("YardExportList");
        //     this.updateItems(this.getYardExportList);
        //   case 'I':
        //     console.log("ImportLoadList");
        //     this.updateItems(this.getImportLoadList);
        //   case 'E':
        //     console.log("DirectExportList");
        //     this.updateItems(this.getDirectExportList);
        //   case 'TL':    
        //     console.log("TruckLoadList");
        //     this.updateItems(this.getTruckLoadList);  
        // }

        //this.updateItems(this.getYardExportList);
        this.disableSave = true;
        this.isSetAppointment = false;
        this.isSetDriverGroup = false;
        this.isAsgDriver = false;
        this.disableAppt = true;
        this.isSetPIN = false;
        if (this.selectDType == "I") {
           this.isYI = true;
        } else {
           this.isYI = false;
        }
        
        this.$store.dispatch('stcDriverGroup', this.searchDriverGroupReq);
        //await api.post('/api/w/stc/WebSearchDriverGroup', this.searchDriverGroupReq).then((driverGroup) => {
        await newAPIPost('/api/w/stc/WebSearchDriverGroup', this.searchDriverGroupReq).then((driverGroup) => {
          this.stcDriverGroups = driverGroup;
        })

        //console.log("stc driver groups: " + JSON.stringify(allSTCDriverGroups)); 
        //console.log("stc driver groups: " + this.getSTCDriverGroup); 
        //console.log("stc driver groups: " + JSON.stringify(this.stcDriverGroups))
        //const allSTCDriverGroups = this.getSTCDriverGroup;
        console.log(`loading driver group in dispatch load mounted`);
        if (this.stcDriverGroups) {
          this.stcDriverGroups.forEach( (val) => {
              const p_driverGrp = this.stcDriverGroupOption.filter( it => it === val.driverGroup);
              if (p_driverGrp.length == 0)
                 this.stcDriverGroupOption.push(val.driverGroup);
          })
          
        }      

        //console.log("stcDriverGroupOption: " + this.stcDriverGroupOption);
        //console.log("isYI: " + this.isYI); 
          
    },

     methods: {

       handleOfficeChanged(id) {
        this.searchRequest.salesOffice = id;
      },

      sortFunction(sortFiled){
                const nullValues = _.filter(this.items, (item) => {
                  return item[sortFiled] == null
                })
                const values = this.items.filter(it => it[sortFiled] != null);
                const sorted = _.sortBy(values,sortFiled).concat(nullValues);
                this.sortStatus = !this.sortStatus;
                if (this.sortStatus)
                {
                    this.items = sorted;
                }
                else
                {
                    this.items = sorted.reverse();
                }
          },



      handleWindowsChanged(id) {
        this.searchRequest.receivingWindow = id;
      },
      handleDrGroupChanged(id) {
        this.searchRequest.driverGroup = id;
      },
      handleStageStatusChanged(id) {
        this.searchRequest.stageStatus = id;
      },
      handleCtnrTypeChanged(id) {
        this.searchRequest.ctnrType = id;
      },

      toggleContainerCopy(element){
          this.containerCopy = true;
          setTimeout(() => {  this.containerCopy = false; }, 2000);
          var el = document.createElement('textarea');
          el.value = element;
          el.setAttribute('readonly', '');
          el.style = {position: 'absolute', left: '-9999px'};
          document.body.appendChild(el);
          el.select();
          document.execCommand('copy');
          document.body.removeChild(el);
      },

      toggleDispatch(element) {
          alert("call to pop-up dispatch" + element);
      },

        updateItems(itemsSource) {
          var items = JSON.parse(JSON.stringify(itemsSource));
          var driverId = "";
          items.forEach((it) => {
            driverId = this.getdriverfromId(it.driverId);
            it.backGroud = false;
            it.selected = false;
            it.editing = false;
            if (it.pushStatus != "A" && it.stcDriverName != "") //check if driver assigned from web
               it.driverId = it.stcDriverName;
            else   
               it.driverId = driverId;
            //console.log(it.driverId);
            //if (it.seqNo == "C000013119")
               //console.log("item seqNo: " + it.seqNo + ", item doProcess: " + it.doProcess + ", item stageCount: " + it.stageCount);
            it.inYardDate = this.convertDateForDatePicker(it.inYardDate,"IY");
            it.gwDate = this.convertDateForDatePicker(it.gwDate,"GW");
            it.chzEndDate = this.convertDateForDatePicker(it.chzEndDate, "CE");
            it.chzStartDate = this.convertDateForDatePicker(it.chzStartDate,"CE");
            it.moveInDate = this.convertDateForDatePicker(it.moveInDate,"CE");
            //console.log("chzStartDate: " + it.chzStartDate);
          });
          this.items = items;
          if (this.notifyMessage != null)
          {
            this.notifyActive = true;
            
          }

       },

       allowUpdateLoadStatus() {
           return (this.selectDType == "I" || this.selectDType == "E"
                   || this.selectDType == "TL"); 
       },

       getLoadStatusLog(item) {
          //alert("test: " + item.seqNo);
          this.$refs.LoadStatusLog.openDialog(item); 
       },

       async updateDrivers(itemsSource) {
           //console.log("update drivers itemsource: " + JSON.stringify(itemsSource));
           //console.log("update drivers itemsource with filter: " + JSON.stringify(itemsSource.filter(it => it.source == "OUTBOUND")));
           var items = itemsSource.filter( it => it.driverOffice == "STC" && it.active == true);
           //var items = itemsSource;
           if (items && items.length > 0) {
              items.forEach( (it) => {
                var driverInfo = it.shortId + "(" + it.userName + ")";
                this.drivers.push(driverInfo);
                this.driverIds.push(it.driverId);
                this.driverNames.push(it.userName);
                this.driverContent.push(driverInfo);
              })
              //console.log("get driver from foreach: " + JSON.stringify(this.drivers));
           } else {
              //await api.post('/api/w/gstMasterData/driverMasterData', this.searchDriverSearchReq)
              await newAPIPost('/api/w/gstMasterData/driverMasterData', this.searchDriverSearchReq)
                 .then ( (driverinfo) => {
                    if (driverinfo) {
                        driverinfo.forEach( (it) => {
                            //console.log("driver: " + it.shortId);
                            var driverInfo = it.shortId + "(" + it.userName + ")";
                            this.drivers.push(driverInfo);
                            this.driverIds.push(it.driverId);
                            this.driverNames.push(it.userName);
                            this.driverContent.push(driverInfo);
                        })
                    }
                 });

           }
           //console.log("drivers: [[" + this.drivers + "]]");
          // var items = JSON.stringify(itemsSource);
          // var items1 = JSON.parse(items);
          // console.log("update drivers: " + items + ", " + items1);
          // // items.forEach(it => {
             
          // // })
          // console.log("items1 length: " + items1.length);
          // items1.forEach((it) => {
          //    console.log("items: " + JSON.stringify(it.shortId));
          //    var driverinfo = JSON.stringify(it.shortId);
          //    this.drivers.push(driverinfo);
          // })
          // //this.drivers = items;
          // console.log("drivers: " + this.drivers);

          //// before get driver info in run time and will slow down the process
          // await api.post('/api/w/gstMasterData/driverMasterData', this.searchDriverSearchReq)
          //        .then ( (driverinfo) => {
          //           if (driverinfo) {
          //               driverinfo.forEach( (it) => {
          //                   console.log("driver: " + it.shortId);
          //                   this.drivers.push(it.shortId + "(" + it.driverId + ")");
          //                   this.driverIds.push(it.driverId);
          //                   this.driverNames.push(it.userName);
          //                   this.driverContent.push(it.shortId + "(" + it.driverId + ")");
          //               })
          //           }
          //        });
          // console.log("drivers: [[" + this.drivers + "]]");
        },

       showRemark(remark) {
          alert(remark);
       },
          
       updateDriverGroupItems(itemsSource) {
          var items = JSON.parse(JSON.stringify(itemsSource));
          this.stcDriverGroups = items;
       },

      getPhotoName(photo) {
          const photoName = decodeURI(photo.imgUrl.replace(/.*\//g, ""));
          return `${this.filePrefixForEachFile || ''}${photoName}`;
      },

      async toggleItemLink(item) {
           const logId = "DISPATCH";
           const imgType = "C";
           this.isPictureModalShowing = true;
           this.isLoading = true;
           //this.photos = (await api.post('/api/w/ccr/photo/getCCRPhoto', { logId: logId, imageType: imgType, imagePath: item.driverCntrImg }));
           this.photos = (await newAPIPost('/api/w/ccr/photo/getCCRPhoto', { logId: logId, imageType: imgType, imagePath: item.driverCntrImg }));
           //console.log("photos length: " + this.photos.length);
           if (item.loadKey != null)
              this.photoZipFileName = `${logId}_${item.loadkey}.zip`;
           else
              this.photoZipFileName = `${logId}_` + imgType + `.zip`;
           this.filePrefixForEachFile = `${item.containerNo}-`;
           this.photoTitle = "Container Image";
           //console.log(this.photos)
           //window.open(item.driverCntrImg, 'test', 'width=400,height=200,scrollbars=yes'); 

      },

      needLock(item) {
           if (item.loadStatus === "BLC" ||
               item.loadStatus === "CFM" ||
               item.loadStatus === "LOK")
               return true;
           else 
               return false;    
      },

      chkloadbkcarrier(item) {

         console.log("item booking: " + item.bookingNo + ", carrier: " + item.carrier + ", load carrier: " + item.loadBookingCarrier);

         if (item.bookingNo != null && item.bookingNo != "" && item.carrier != this.getContentFromBrace(item.loadBookingCarrier)) {
            return false;
         } else {
            return true;
         }
      },


      toggleItemLink1(item) {
         var imgLink = "";
         var title = "";
         var width;
         var height;
         var leftPos;
         var topPos;
         var settings = "";
         var userWidth = screen.availWidth;
         var userHeight = screen.availHeight;        
         width =  400;
         height = 200;
         //leftPos = (userWidth - width) /2;
         //leftPos = 1500;
         leftPos = userWidth - 500;
         topPos = (userHeight - height) /2;
         //console.log("leftPos: " + leftPos + " topPos: " + topPos);
         //console.log("avail height: " + userHeight + " avail width: " + userWidth);
         settings += 'left=' + leftPos + ',top=' + topPos + ',width=' + width + ',height=' + height;
         settings += ',scrollbars=yes';
         //console.log("settings: " + settings);
         imgLink = item.driverCntrImg;
         title = "Driver Container Image";
        if (! window.focus)return true;
           var href;
        if (typeof(imgLink) == 'string') href=imgLink;
        else href=imgLink.href; 
        //window.open(href, title, 'width=400,height=200,scrollbars=yes'); 
        //console.log("href: " + href);
        if (href.toString().indexOf('http') < 0) {
           //console.log("index: " + href.toString().indexOf('http'));
           alert("Not a valid picture path");
        }   
        else {
          window.open(href, title, settings,true);
        }
        return false;         
      },
      // testpop(item) {
      //   console.log("testpop: " + item.driverCntrImg);
      //   var mylink = item.driverCntrImg;
      //   //var mylink = "https://www.google.com";
      //   if (! window.focus)return true;
      //      var href;
      //   if (typeof(mylink) == 'string') href=mylink;
      //   else href=mylink.href; 
      //   window.open(href, 'Image', 'width=400,height=200,scrollbars=yes'); 
      //   return false; 

      // },

       onSelectDType(val) {
          //console.log("Dispatch type: " + val);
          this.selectDType = val;
          if (this.selectDType == "I") this.isYI = true; else this.isYI = false;
          this.doSearch();
       },
       
       doSearch() {

          //var tmp_moveindate_start = this.searchRequest.moveInDate.startDate;
          //var tmp_moveindate_end = this.searchRequest.moveInDate.endDate;
          const {
          users,
          teams,
          salesOffice,
        } = this.searchRequest;
        this.active = false;

        this.items = [];
        //this.notifyMessage = null;
        //this.searchRequest.chzStartDate.startDate = moment().subtract(2,'months').startOf('d').toDate();
        //this.searchRequest.chzStartDate.endDate = moment().add(2,'months').endOf('d').toDate();
        this.searchRequest.driverId = this.getContentFromBrace(this.searchRequest.driverId);
        this.searchRequest.containerNo = (this.searchRequest.containerNo)? this.searchRequest.containerNo.toUpperCase() : this.searchRequest.containerNo;
        this.searchRequest.chassisNo = (this.searchRequest.chassisNo)? this.searchRequest.chassisNo.toUpperCase() : this.searchRequest.chassisNo;

        //console.log("search request-loadStatus: " + this.searchRequest.loadStatus);
        this.searchRequest.salesOffice = "LGB";
        //console.log("moveindate start: " + this.searchRequest.moveInDate.startDate);
        //console.log("moveindate end: " + this.searchRequest.moveInDate.endDate);
        var sendToReq = JSON.parse(JSON.stringify(this.searchRequest));
        console.log("sendToReq: " + JSON.stringify(sendToReq));
        if (sendToReq.moveInDate && sendToReq.moveInDate.startDate)
           sendToReq.moveInDate.startDate = this.convertDateForMoveIn(sendToReq.moveInDate.startDate,"-");
        if (sendToReq.moveInDate && sendToReq.moveInDate.endDate)   
           sendToReq.moveInDate.endDate = this.convertDateForMoveIn(sendToReq.moveInDate.endDate,"-");
        if (sendToReq.cargoCutOff && sendToReq.cargoCutOff.startDate)
           sendToReq.cargoCutOff.startDate = this.convertDateForMoveIn(sendToReq.cargoCutOff.startDate,"-");
        if (sendToReq.cargoCutOff && sendToReq.cargoCutOff.endDate)
           sendToReq.cargoCutOff.endDate = this.convertDateForMoveIn(sendToReq.cargoCutOff.endDate,"-");
        if (sendToReq.inGateDate && sendToReq.inGateDate.endDate)
           sendToReq.inGateDate.endDate = this.convertDateForMoveIn(sendToReq.inGateDate.endDate,"-");
           if (sendToReq.inGateDate && sendToReq.inGateDate.startDate)
           sendToReq.inGateDate.startDate = this.convertDateForMoveIn(sendToReq.inGateDate.startDate,"-");
        if (sendToReq.driverId == "")
           sendToReq.driverId = null
        if (sendToReq.cargoCutOff) {      
           console.log("cutoff start: " + sendToReq.cargoCutOff.startDate);
           console.log("cutoff end: " + sendToReq.cargoCutOff.endDate);
        }  
        // if (!sendToReq.apptDate) {
        //    sendToReq.apptDate.startDate = "";
        //    sendToReq.apptDate.endDate = "";
        // } 
       //console.log("select D type: " + this.selectDType);
        //console.log("moveindate start: " + this.searchRequest.moveInDate.startDate);
        //console.log("moveindate end: " + this.searchRequest.moveInDate.endDate);
        if (this.selectDType == "YE") {
            //console.log("search:YardExportList");
            this.searchRequest.type = "YY";
            sendToReq.type = "YY";
            //this.$store.dispatch('loadYardExportList', this.searchRequest);
            this.$store.dispatch('loadYardExportList', sendToReq);
        }
        else if (this.selectDType == "I") {
            //console.log("search:ImportLoadList");
            this.searchRequest.type = "YI";
            sendToReq.type = "YI";
            //this.$store.dispatch('importLoadList', this.searchRequest);
            //this.$store.dispatch('loadYardExportList', this.searchRequest);
            this.$store.dispatch('loadYardExportList', sendToReq);
        }
        else if (this.selectDType == "E") {
            //console.log("search:DirectExportList");
            this.searchRequest.type = "YE";
            sendToReq.type = "YE";
            //this.$store.dispatch('directExportList', this.searchRequest);
            //this.$store.dispatch('loadYardExportList', this.searchRequest);
            this.$store.dispatch('loadYardExportList', sendToReq);
        }  
        else if (this.selectDType == "TL") {
            //console.log("search:TruckLoadList");
            this.searchRequest.type = "YT";
            sendToReq.type = "YT";
            //this.$store.dispatch('truckLoadList', this.searchRequest);
            //this.$store.dispatch('loadYardExportList', this.searchRequest);
            this.$store.dispatch('loadYardExportList', sendToReq);
        }  
        //this.searchRequest.moveInDate.startDate = tmp_moveindate_start;
        //this.searchRequest.moveInDate.endDate = tmp_moveindate_end;

        // switch (this.selectDType) {
        //   default:
        //     this.searchRequest.type = "";
        //     console.log("search:YardExportList");
        //     this.$store.dispatch('loadYardExportList', this.searchRequest);
        //   case 'I':
        //     this.searchRequest.type = "YI";
        //     console.log("search:ImportLoadtList");
        //     this.$store.dispatch('importLoadList', this.searchRequest);
        //   case 'E':
        //     this.searchRequest.type = "YE";
        //     console.log("search:DirectExportList");
        //     this.$store.dispatch('directExportList', this.searchRequest);
        //   case 'TL':      
        //     this.searchRequest.type = "YT";
        //     console.log("search:TruckloadList");
        //     this.$store.dispatch('truckLoadList', this.searchRequest);
        // }
        this.isSetDriverGroup = false;
        this.isSetAppointment = false;
        this.isAsgDriver = false;
        this.isSetPin = false;
        this.isConfirm = false;
        this.disableSave = true;
        this.disableAppt = true;

       },

      //  async doCopy() {
      //     const request = this.getSelectedItems[0];
      //     if (request.loadKeyWithStageNo == null)
      //     {
      //       alert('There is no stage selected');
      //       return;
      //     }
      //     const data = {
      //       companyOffice: "GST_" + request.salesOffice,
      //       loadKeyWithStageNo: request.loadKeyWithStageNo,
      //       type: request.type || "YY",
      //       loadKey: request.seqNo,
      //       carrier: request.carrier,
      //       action: "COPY",
      //     }

      //     console.log(data);

      //     api.post("/api/w/gst/WebCopyDeleteStage", data)
      //     .then(() => {
      //       this.$store.commit('clearApiError');
      //       this.doSearch();
      //     });

      //  },

      async onRefreshLoadStatus(status) {
         console.log("load status from refreshLoadStatus: " + status);
         this.doSearch();
      },

      async doDeleteBooking(){
          const request = this.getSelectedItems[0];
          const data = {
            user: 'GST_SYSTEM',
            seqNo: request.seqNo,
            mode: "REMOVE"
          }
          //api.post("/api/w/DOs/WebAssignDoHeaderWithStage", data)
          newAPIPost("/api/w/DOs/WebAssignDoHeaderWithStage", data)
          .then(() => {
            this.$store.commit('clearApiError');
            this.doSearch();
          });
      },


       async doDeleteStage(){
        const request = this.getSelectedItems[0];
          //console.log(request);
          const data = {
            companyOffice: "GST_" + request.salesOffice,
            loadKeyWithStageNo: request.loadKeyWithStageNo,
            type: request.type || "YY",
            loadKey: request.seqNo,
            action: "DELETE_STAGE",
          }
          if (request.loadKeyWithStageNo == null)
          {
            alert('There is no stage selected');
            return;
          }

          //api.post("/api/w/gst/WebCopyDeleteStage", data)
          newAPIPost("/api/w/gst/WebCopyDeleteStage", data)
          .then(() => {
            this.$store.commit('clearApiError');
            this.doSearch();
          });

       },

       async onfresh(id, ticket, mode, loads) {
         //console.log(`${id} , ${ticket} , ${mode}`);
         this.notifyMessage =  null;

         switch(mode)
         {
           case 'STR':
              this.notifyMessage = `Load ${id} has been scaled tw with scale ticket: ${ticket}.`;
           break;

           case 'SWR':
              this.notifyMessage = `Load ${id} with scale ticket: ${ticket} has been scaled gw.`;
           break;

           case 'ASN':
              this.notifyMessage = `DO ${id} with booking#: ${ticket} has been assigned with your selection. Loads: {${loads}}`;
           break;

           case 'UASN':
              this.notifyMessage = `DO ${id} with booking#: ${ticket} has been assigned with your selection. Loads: {${loads}}`;
           break;

           default:
           break;
         }
      
         this.doSearch();
       },

       async updateDriverGroup(driverGroup, mode) {
          //console.log("onUpdate: " + driverGroup + ", mode: " + mode);
          var selectItems = this.getSelectedItems;
          //console.log("selectItems length: " + selectItems.length);
          //console.log("selectItems: " + selectItems);
          selectItems.forEach( (it) => {
             it.driverGroup = driverGroup;
             it.pushStatus = "P";
          })
          //console.log("selectItems: " + selectItems);
          this.disableSave = !this.disableSave;
       },

       async doDeleteLoad(){
        const request = this.getSelectedItems[0];
          //console.log(request);
          const data = {
            companyOffice: "GST_" + request.salesOffice,
            loadKeyWithStageNo: request.loadKeyWithStageNo,
            type: request.type || "YY",
            loadKey: request.seqNo,
            action: "DELETE_LOAD",
          }

          //api.post("/api/w/gst/WebCopyDeleteStage", data)
          newAPIPost("/api/w/gst/WebCopyDeleteStage", data)
          .then(() => {
            this.$store.commit('clearApiError');
            this.doSearch();
          });

       }, 

       doClear(){
        this.filter = "";
        // this.items = this.getYardExportList
        //this.updateItems(this.getYardExportList);
        // this.searchRequest.receivingWindow = "";
        // this.searchRequest.cargoCutOff.startDate = "";
        // this.searchRequest.cargoCutOff.endDate = "";
        // this.searchRequest.apptDate.startDate = "";
        // this.searchRequest.apptDate.endDate = "";
        // this.searchRequest.bookingNo = "";
        // this.searchRequest.stageStatus = "";
        // this.searchRequest.driverGroup = "";
        // this.searchRequest.appointment = "";
        // this.searchRequest.pushStatus = "";
        // this.searchRequest.loadStatus = ["ASG","LD"]
        // this.searchRequest.freightType = "";
        // this.searchRequest.driver = "";
        // this.searchRequest.chassisNo = "";
        // this.searchRequest.containerNo = "";
        // this.searchRequest.deliveryOrder = "";
        // this.searchRequest.carrier = "";
        // this.searchRequest.customerOrder = "";
        // this.searchRequest.loadKey = "";

       this.$nextTick(() => {
          if (this.$el && this.$el.querySelectorAll)
          {
            _(this.$el.querySelectorAll('.searchPanel .md-field button.md-input-action.md-clear'))
              .each((it) => {
                it.click();
              });
          }  
          this.searchRequest = getInitSearch();
          this.searchRequest.salesOffice = 'LGB';
          //this.items = this.getOutboundsList;
          //this.updateItems(this.getOutboundsList);
          //this.edit = getInitEdit();
        });

       },

       editDriverGroup() {
         //this.isSetDriverGroup = true;
         //this.disableSave = false;
         var selectItems = this.getSelectedItems;
         var selectedItemCount = selectItems.length;
         var hasError = false;

         this.showDropDown = false;

         if (selectedItemCount > 0) {
            selectItems.forEach( (it) => {
               if (it.driverGroup && it.driverGroup != "" && (it.pushStatus == "C" || it.pushStatus == "R" || it.pushStatus == "A")) {
                  hasError = true;
               }
               else {
                //this.disableSave = !this.disableSave;
                this.$refs.UpdateDriverGroupForm.openDialog(selectItems);
               }
            })
         } else {
           this.isSetDriverGroup = !this.isSetDriverGroup;
           this.disableSave = !this.disableSave;
         }
         if (hasError) {
           alert("Error: One or more items already have driver group assigned!");
         }
       },

       doAsgDriver() {
         //this.isAsgDriver = true;
         //this.disableSave = false;
         this.isAsgDriver = !this.isAsgDriver;
         this.disableSave = !this.disableSave;
         console.log("driver list from doAsgDriver: " + this.drivers);
         this.showDropDown = false;
       },

       doAdditionCharge() {
        var selectItems = this.getSelectedItems;
        //var isexisted = this.checkAdditionChargeExist(selectItems[0]);
        //console.log("isexisted: " + JSON.stringify(isexisted));
        if (selectItems.length != 1) {
           alert("Please select only 1 container to process!" + selectItems.length);
        } else {
          //  if (isexisted == true) {
          //       console.log('addition charge existed');
          //       this.doUpdateAdditionCharge();
          //  } else {
          //       console.log('addition charge not existed');
          //       this.doNewAdditionCharge();
          //  }
          this.checkAdditionChargeExist(selectItems[0]);
        }
        this.showDropDown = false;
       },



       async checkAdditionChargeExist(selectItem) {
          console.log("selectItem in check: " + JSON.stringify(selectItem));
          //var agreement =  "TEST-" + selectItem.containerNo;
          var deliveryOrder = selectItem.deliveryOrder;
          //var cutlfd = selectItem.cutLFD;
          console.log("deliveryOrder: " + deliveryOrder);
          //this.agreementSearchRequest.agreement = agreement;
          //this.agreementSearchRequest.agreement = "10001";
          this.agreementSearchRequest.salesOffice = "LGB";
          this.cutoffdate.startDate = selectItem.cutLFD;
          this.cutoffdate.endDate = selectItem.cutLFD;
          //const selectedcontaineragreement = await api.post('/api/w/apar/chassislist',{salesOffice:'LGB',seqNo:selectItem.seqNo});
          //const selectedcontaineragreement = await api.post('/api/w/do/doheader',{salesOffice:'LGB',deliveryOrder:deliveryOrder,cutLFD: this.cutoffdate})
                 
          this.agreementSearchRequest.agreement = selectItem.doAgreement + '-' + selectItem.containerNo;
          var agreement = this.agreementSearchRequest.agreement;
          console.log("show agreement: " + agreement);
          //const chkadditionchargeagreement = await api.post('/api/w/gst/gstpriceagreement/search', this.agreementSearchRequest);
          const chkadditionchargeagreement = await newAPIPost('/api/w/gst/gstpriceagreement/search', this.agreementSearchRequest);

          if (chkadditionchargeagreement != null && chkadditionchargeagreement.length > 0) {
             console.log("chkadditionchargeagreement: " + JSON.stringify(chkadditionchargeagreement));
             //return true;
             this.agreementItems.push(chkadditionchargeagreement);
             this.doUpdateAdditionCharge();
          } else {
             //console.log("selectedcontaineragreement: " + JSON.stringify(selectedcontaineragreement));
             //if (selectedcontaineragreement != null && selectedcontaineragreement.length > 0) {
                //this.agreementHeaderInfo.agreement = selectedcontaineragreement[0].agreement;
                //return false;
                this.doNewAdditionCharge(agreement);
             //}
          }


          // await api.post('/api/w/gst/gstpriceagreement/search', this.agreementSearchRequest).then(
          //    (it) => {
          //       console.log("get agreement: " + JSON.stringify(it));
          //       if (it && it.agreement == this.agreementSearchRequest.agreement)
          //       {
          //          this.agreementItems.push(it);
          //          return true;
          //       }
          //       else {
          //          var containerAgreement = this.getAgreementBySeqNo(selectItem);
          //          console.log("containerAgreement: " + containerAgreement);
          //          if (containerAgreement != null) {
          //             console.log("getcontainerAgreement: " + containerAgreement);
          //             if (containerAgreement.agreement && containerAgreement.agreement != '') {
          //                this.agreementSearchRequest.agreement = containerAgreement;
          //                this.agreementSearchRequest.salesOffice = "LGB";
          //                api.post('/api/w/gst/gstpriceagreement/search', this.agreementSearchRequest)
          //                   .then( (it) => {
          //                     console.log("get agreement for new: " + JSON.stringify(it));
          //                     if (it && it.length > 0) {
          //                        this.agreementHeaderInfo.agreement = it[0].agreement;
          //                        this.agreementHeaderInfo.adesc = it[0].adesc;
          //                        this.agreementHeaderInfo.validFrom = it[0].validFrom;
          //                        this.agreementHeaderInfo.validTo = it[0].validTo;
          //                        this.agreementHeaderInfo.signedBy = it[0].signedBy;
          //                        this.agreementHeaderInfo.departureCode = it[0].departureCode;
          //                        this.agreementHeaderInfo.destinationCode = it[0].destinationCode;
          //                        this.agreementHeaderInfo.commodity = it[0].commodity;
          //                        this.agreementHeaderInfo.freeDay = it[0].freeDay;
          //                        this.agreementHeaderInfo.ctnType = it[0].ctnType;
          //                        this.agreementHeaderInfo.orderType = it[0].orderType;
          //                        this.agreementHeaderInfo.currency = it[0].currency;
          //                        this.agreementHeaderInfo.allInRate = it[0].allInRate;
          //                        this.agreementHeaderInfo.paymentTerm = it[0].paymentTerm;
          //                        this.agreementHeaderInfo.payer = it[0].payer;
          //                        this.agreementHeaderInfo.extendedBy = it[0].extendedBy;
          //                        this.agreementItems.push(this.agreementHeaderInfo);
          //                     }
          //                   }   
          //                )
          //             }  
          //          }
          //          return false;
          //       }
          //    }
          //);          
       },


       async getAgreementBySeqNo(selectItem) {
          //await api.post('/api/w/apar/chassislist',{salesOffice:'LGB',seqNo:selectItem.seqNo})
          await newAPIPost('/api/w/apar/chassislist',{salesOffice:'LGB',seqNo:selectItem.seqNo})
            .then( 
               (it) => {
                 console.log("result from chassislist: " + JSON.stringify(it) + ", " + it.length);
                 if (it && it.length > 0) {
                    console.log("agreementbyseqno: " + JSON.stringify(it[0].agreement));
                    return JSON.stringify(it[0].agreement);
                 }
                 else {
                    return null;
                 }
               }
            )
       },

       saveLoadSearchCriteria() {
         this.searchCriteria.containerNo = this.searchRequest.containerNo;
         this.searchCriteria.receivingWindow = this.searchRequest.receivingWindow;
         this.searchCriteria.salesOffice = this.searchRequest.salesOffice;
         this.searchCriteria.pickupLocation = this.searchRequest.pickupLocation;
         this.searchCriteria.bookingNo = this.searchRequest.bookingNo;
         this.searchCriteria.destination = this.searchRequest.destination;
         this.searchCriteria.appointment = this.searchRequest.appointment;
         this.searchCriteria.driverId = this.searchRequest.driverId;
         this.searchCriteria.driverGroup = this.searchRequest.driverGroup;
         this.searchCriteria.costRelevant = this.searchRequest.costRelevant;
         this.searchCriteria.freightType = this.searchRequest.freightType;
         this.searchCriteria.loadKey = this.searchRequest.loadKey;
         this.searchCriteria.source = this.searchRequest.source;
         this.searchCriteria.chassisNo = this.searchRequest.chassisNo;
         this.searchCriteria.ctnrType = this.searchRequest.ctnrType;
         this.searchCriteria.carrier = this.searchRequest.carrier
         this.searchCriteria.customerOrder = this.searchRequest.customerOrder;
         this.searchCriteria.deliveryOrder = this.searchRequest.deliveryOrder;
         this.searchCriteria.loadStatus = this.searchRequest.loadStatus;
         this.searchCriteria.pushStatus = this.searchRequest.pushStatus;
         this.searchCriteria.stageType = this.searchRequest.stageType;
         this.searchCriteria.cargoCutOff.startDate = this.searchRequest.cargoCutOff.startDate;
         this.searchCriteria.apptDate.startDate = this.searchRequest.apptDate.startDate;
         this.searchCriteria.cargoCutOff.endDate = this.searchRequest.cargoCutOff.endDate;
         this.searchCriteria.apptDate.endDate = this.searchRequest.apptDate.endDate;
         this.searchCriteria.moveInDate.startDate = this.searchRequest.moveInDate.startDate;
         this.searchCriteria.moveInDate.endDate = this.searchRequest.moveInDate.endDate;
         this.searchCriteria.inGateDate.startDate = this.searchRequest.inGateDate.startDate;
         this.searchCriteria.inGateDate.endDate = this.searchRequest.inGateDate.endDate;
         this.searchCriteria.filter = this.filter;
         this.searchCriteria.selectDType = this.selectDType;
         this.searchCriteria.fromPage = "L";

       },


       doNewAdditionCharge(agreement) {
         console.log("new addition charge agreement: " + agreement);
         //var selectItem = this.agreementHeaderInfo;
         var selectItems = this.getSelectedItems;
         console.log("selectItem agreement: " + selectItems[0].doAgreement);
         var additionchargeagreement = agreement;
         this.saveLoadSearchCriteria();
         this.$router.push({ 
           name: "PriceMaint" , 
           params: 
            {
              mode : 'CREATEAC',
              agreement: selectItems[0].doAgreement,
              additionchargeagreement: additionchargeagreement,
              salesOffice: 'LGB',
              from: 'LOAD',
              searchCriteria: JSON.stringify(this.searchCriteria)
            }})
       },
       doUpdateAdditionCharge() {
         console.log("agreementItems:" + JSON.stringify(this.agreementItems) + ", " + this.agreementItems.length);
         this.saveLoadSearchCriteria();
         if (this.agreementItems && this.agreementItems.length > 0) {
            const request = this.agreementItems[0];
            const agreement = request[0].agreement;
            const salesOffice = request[0].salesOffice;
            console.log("request: " + JSON.stringify(request) + ", " + JSON.stringify(agreement));
            
      //  request.forEach((it) => {
      //       it.mode = 'CHANGE'
      //     });
         request.mode = 'CHANGE';
         this.$router.push({ 
            name: "PriceMaint" , 
            params: {
              mode: 'CHANGE',
              agreement: agreement,
              salesOffice: 'LGB',
              from: 'LOAD',
              searchCriteria: JSON.stringify(this.searchCriteria)
            }
          })
         }
       },

       editAppt() {
         this.disableAppt = !this.disableAppt;
         this.disableSave = !this.disableSave;
         this.showDropDown = false;
         //this.disableAppt = false;
         //this.disableSave = false;
       },

       async doChange(){
         
        const request = this.getSelectedItems[0];
          if (request.loadKeyWithStageNo == null)
          {
            alert('There is no stage selected');
            return;
          }

          if (request.stageStatus == 'STC' || request.stageStatus == 'SUC'  )
          {
            alert('The stage has been confirmed or under check, it can not be changed this time!');
            return;
          }

          this.$refs.DispatchFormChange.openDialog(request);

    },


    async doCopy(){
        const request = this.getSelectedItems[0];
          if (request.loadKeyWithStageNo == null)
          {
            alert('There is no stage selected');
            return;
          }

          this.$refs.DispatchFormCopy.openDialog(request);

    },

    doDispatch(){
        do {
            this.selectedItems.pop();
        } while (this.selectedItems.length > 0)
        //console.log("selectedItems length: " + this.selectedItems.length);
        var items = this.items.forEach( it => {
          if (it.selected == true)
          {
            //console.log("selected: " + it.selected);
            this.selectedItems.push(it);
          }
        })
        //console.log("dispatch items: " + JSON.stringify(this.selectedItems));
        const request = this.selectedItems[0];
        this.$refs.DispatchFormCopy.openDialog(request);

    },

    doSingleDispatch(item){
        // const request = item;
        // this.$refs.DispatchFormCopy.openDialog(request);
        //console.log("single dispatch item: " + JSON.stringify(item));
        // this.cockpitRequest.mode = "YY";
        // this.cockpitRequest.carrierName = "";
        // this.cockpitRequest.customerPO = "";
        // this.cockpitRequest.route = "";
        // this.cockpitRequest.deliveryOrder = "";
        // if (item.loadKey == null)
        //    this.cockpitRequest.loadKey = item.seqNo;
        // else
        //    this.cockpitRequest.loadKey = item.loadKey; 
        if (item.loadKey == null)
           item.loadKey = item.seqNo;
        this.singleReq.push(item);    
        this.$router.push({  
              name: "cockpit" , 
              params: { req: JSON.stringify(this.singleReq) }
        })

    },

    doPIN() {
        if (this.selectDType == "I") {
           this.isSetPIN = !this.isSetPIN;
           this.disableSave = !this.disableSave;
        }
    },

    doConfirm() {
       this.isConfirm = !this.isConfirm;
       this.disableSave = !this.disableSave;
    },

    doUpdateStatus() {
       console.log("select item number: " + JSON.stringify(this.getSelectedItems[0]));
       //if (this.getSelectedItems.length == 1 && this.checkUpdateLoadStatus(this.getSelectedItems[0])) {
          this.$refs.UpdateStcContainerStatusForm.openDialog(this.getSelectedItems[0]); 
       //} else {
       //  alert("Not allow to update load status!! Please check load status or not selected any entry");
      // }
    },

    checkUpdateLoadStatus() {
       if (this.getSelectedItems.length != 1) {
          return true;
       } else { // enable update load status button
          var item = this.getSelectedItems[0]; 
          if (item.loadStatus == "BLC" || item.loadStatus == "CFM" || item.loadStatus == "LOK") {
            return true;
          } else {  
            return false;
          }
       }
       

       if (item && item.loadStatus != null) {
          if (item.loadStatus == "BLC" || item.loadStatus == "CFM" || item.loadStatus == "LOK") {
             return false;
          } else {
            return true;
          }
       }
    },
    checkPushStatus(item, status) {
       if (status == "C" && this.isConfirm) item.pushStatus = "C";
       if (status == "REJ" && this.isConfirm) item.pushStatus ="REJ";
    },
    chkItemPushStatus(item,type) {
       if (type == "driverId") {
          //if (item.pushStatus == "REJ" || item.pushStatus == "R" || item.pushStatus == "C" || item.pushStatus == "A" || item.pushStatus == "P") 
          // if (item.selected) {
          //    console.log("selected item to check push status: " + JSON.stringify(item));
          // }
          if (item.pushStatus == "C" || item.pushStatus == "A") {
             if (!item.selected)
               return false;
             else
               return true;
          } else 
             return true;  
       }
       else if (type == "driverGroup") {
        if (item.pushStatus == "R" || item.pushStatus == "C" || item.pushStatus == "A") 
             return false;
          else 
             return true;  
       }    
    },
    getContentFromBrace(inputVal) {
      var openbraceIndx = -1;
         var closebraceIndx = -1;
         var retVal = "";
         if (inputVal && inputVal != "") {
            openbraceIndx = inputVal.indexOf("(");
            closebraceIndx = inputVal.indexOf(")");
            if (openbraceIndx >= 1) {
               if (closebraceIndx > openbraceIndx) {
                  retVal = inputVal.substr(openbraceIndx + 1, closebraceIndx - openbraceIndx - 1);
                  //console.log("retVal from brace: " + retVal);
               } else if (closebraceIndx < 0) {
                  retVal = inputVal.substr(openbraceIndx + 1, inputVal.length - openbraceIndx);
                  //console.log("retVal from brace1: " + retVal);
               }
            } else {
               retVal = inputVal;
            }
            return retVal;
         } else {
            return inputVal;
         }    
    },
    getMasterDataByName(group, tagId) {
        //console.log("get master data name: " + group + ", " + tagId);
        if (!tagId) {
          return "";
        }
        //console.log("master name: " + this.getMasterDataName(group, tagId));
        return this.getMasterDataName(group, tagId);
        //return "";
    },

    getDriverIdFromName(driverInfo) {
        if (driverInfo) {
           const searchstrindx = driverInfo.indexOf("(") + 1;
           const endofstringlen = driverInfo.length - searchstrindx - 1;
           if (searchstrindx > 0) {
             //console.log("driverId from getDriverIdFromName: " + driverInfo.substr(searchstrindx, endofstringlen));
             return driverInfo.substr(searchstrindx, endofstringlen);
           }
           else {
             return "";
           }
        } else {
          return "";
        }

    },

    getdriverfromId(id) {
        if (this.driverIds && this.driverContent && id) {
            var indx = 0;
            var storedindx = 0;
            //console.log("getdriverfromid: " + this.driverIds.length + ", " + this.driverNames.length + ", " + this.driverContent.length + ", id: " + id);
            //console.log("driverIds: " + this.driverIds);
            //console.log("driverNames: " + this.driverNames);
            if (!isNaN(id)) {
               this.driverIds.forEach((it) => {
                  //console.log("driverId: " + it);
                  if (it != id) {
                     indx += 1;
                  }
                  else {
                     storedindx = indx;
                  }
               })
            } 
            else {
              this.driverNames.forEach((it) => {
                  //console.log("drivername: " + it);
                  if (it != id) {
                     indx += 1;
                  }
                  else {
                     storedindx = indx;
                  }
               })
            }
            //console.log("index: " + storedindx + ", " + this.driverContent[storedindx]);
            return this.driverContent[storedindx];
        }
        else {
          return null;
        }
        //return id;
    },

    handleTypeChanged(id) {
        this.searchRequest.type = id;
      },


    
    handleCarrierChanged(id) {
        this.searchRequest.carrier = id;
      },


    handleDriverRequestChanged(id) {
        this.searchRequest.driverId = id;
      },

    handleCostRelChanged(id) {
        this.searchRequest.costRelevant = id;
    },

    handleFreightTypeChanged(id) {
        this.searchRequest.freightType = id;
    },

      changeAsgDriverId(item) {
        var pushstatus = item.pushStatus;
        //console.log("asg driver push status: " + item.pushStatus);
        //return (id, name, unit, weight, plate, trail) => {
        return (driver) => {  
          if (this.isValidDriver(driver) && this.isAsgDriver == true) {
             //if (pushstatus && pushstatus != "C" && pushstatus != "R" && pushstatus != "REJ" && pushStatus != "P") {
                if (driver && driver != "") {
                    pushstatus = "A";
                    item.driverGroup = "";
                } else {
                    pushstatus = null;    
                }    
             //}
          }
          //console.log("driver Id: " + id + " plate: " + plate);
          //item.driverId = id;
          item.driverId = driver;
          //item.truckId = plate;
          item.pushStatus = pushstatus;
          //item.driverPh = name;
          //item.driverLP = plate;
          // item.containerNo = trail;
          //console.log("driver Id in item: " + item.driverId);
          
        };
      },

      isValidDriver(id) {
          //console.log("validdrverid: " + id); 
          //console.log("driverContent: " + this.driverContent);
          if (id && id != "") {
            if (this.driverContent.includes(id)) {
              //console.log("return true");
              return true;
            } else {
              //console.log("return false");
              return false;
            }

          }
          else return false;
      },

      changeDriverGroup(item) {
        return (driverGroup) => {
          if (driverGroup) {
            //console.log("driver Group: " + item.driverGroup);
            item.driverGroup = driverGroup.tagId;
          }
        }

      },

      changeDriverGroupPush(item) {
        return (driverGroup) => {
          //console.log("driver group to push: " + driverGroup);
          if (driverGroup && driverGroup != "")
          {
              item.pushStatus = "P";
          }
          else {
            //console.log("remove P from status");
            if (item.pushStatus == "P") item.pushStatus = "";
          }
          item.driverGroup = driverGroup; 
        }
      },

      showApptDate(item) {
        //console.log("item apptDate: " + item.apptDate);
        if (item.apptDate != "12/31/1969" && item.apptDate != null && item.apptDate != "") {
          var date = new Date(item.apptDate);
          //var date = new Date("1/1/2022"); 
          var month = date.getMonth() + 1;
          var day = date.getDate();
          var year = date.getFullYear();
          //console.log("day length:" + day.toString().length);
          if (day.toString().length < 2)
            day = '0' + day;
          if (month.toString().length < 2)
            month = '0' + month;
          //console.log("date: " + date);
          //console.log("test date: " + Date("1/1/2022"));
          //console.log("month: " + month + " day: " + day + " year: " + year);
          item.apptDate = month + "/" + day + "/" + year;
          return item.apptDate;
        }
        else {
          item.apptDate = "";
          return "";
        }
      },

       handlePickLocationChanged(item) {
        return (pickupLocation) => {
          if (pickupLocation) {
            item.pickupLocationCode = pickupLocation.tagId;
            item.pickUpLocationName = pickupLocation.tagName;
            // item.pickUpLocation = pickupLocation;
          } else {
             //item.pickUpLocationId = null;
            // item.pickUpLocationName = null;
            // item.pickUpLocation = null;
          }
        };
      },



      handleDeliverLocationChanged(item) {
        return (pickupLocation) => {
          if (pickupLocation) {
            item.deliverLocationCode = pickupLocation.tagId;
            item.deliverLocationName = pickupLocation.tagName;
            // item.pickUpLocation = pickupLocation;
          } else {
             //item.pickUpLocationId = null;
            // item.pickUpLocationName = null;
            // item.pickUpLocation = null;
          }
        };
      },

      handlePushStatusChanged(id) {
        this.searchRequest.pushStatus = id;
      },

      handleItemPushStatusChanged(item) {
         return (pushstatus) => {
          //console.log("item push status: " + pushstatus);
           item.pushStatus = pushstatus.tagId;
         }
      },
      

      doCockPit() {
        const request = this.uniqByLast(this.getSelectedItems, it => it.seqNo);
          //console.log(request);
          request.forEach((it) => {
            if (this.selectDType == "YE") it.mode = "YY";
            if (this.selectDType == "E") it.mode = "YE";
            if (this.selectDType == "I") it.mode = "YI";
            if (this.selectDType == "TL") it.mode = "YT";
            //it.mode = this.selectDType;
            //it.carrierName = "";
            //it.customerPO = "";
            it.route = "";
            //it.deliveryOrder = "";
            if (it.loadKey == null)
            {
              it.loadKey = it.seqNo;
            }
          });
          this.searchCriteria.containerNo = this.searchRequest.containerNo;
          this.searchCriteria.receivingWindow = this.searchRequest.receivingWindow;
          this.searchCriteria.salesOffice = this.searchRequest.salesOffice;
          this.searchCriteria.pickupLocation = this.searchRequest.pickupLocation;
          this.searchCriteria.bookingNo = this.searchRequest.bookingNo;
          this.searchCriteria.destination = this.searchRequest.destination;
          this.searchCriteria.appointment = this.searchRequest.appointment;
          this.searchCriteria.driverId = this.searchRequest.driverId;
          this.searchCriteria.driverGroup = this.searchRequest.driverGroup;
          this.searchCriteria.costRelevant = this.searchRequest.costRelevant;
          this.searchCriteria.freightType = this.searchRequest.freightType;
          this.searchCriteria.loadKey = this.searchRequest.loadKey;
          this.searchCriteria.source = this.searchRequest.source;
          this.searchCriteria.chassisNo = this.searchRequest.chassisNo;
          this.searchCriteria.ctnrType = this.searchRequest.ctnrType;
          this.searchCriteria.carrier = this.searchRequest.carrier
          this.searchCriteria.customerOrder = this.searchRequest.customerOrder;
          this.searchCriteria.deliveryOrder = this.searchRequest.deliveryOrder;
          this.searchCriteria.loadStatus = this.searchRequest.loadStatus;
          this.searchCriteria.pushStatus = this.searchRequest.pushStatus;
          this.searchCriteria.stageType = this.searchRequest.stageType;
          if (this.searchRequest.cargoCutOff)
             this.searchCriteria.cargoCutOff.startDate = this.searchRequest.cargoCutOff.startDate;
          if (this.searchRequest.apptDate)   
             this.searchCriteria.apptDate.startDate = this.searchRequest.apptDate.startDate;
          if (this.searchRequest.cargoCutOff)   
             this.searchCriteria.cargoCutOff.endDate = this.searchRequest.cargoCutOff.endDate;
          if (this.searchRequest.apptDate)   
             this.searchCriteria.apptDate.endDate = this.searchRequest.apptDate.endDate;
          if (this.searchRequest.moveInDate) {   
             this.searchCriteria.moveInDate.startDate = this.searchRequest.moveInDate.startDate;
             this.searchCriteria.moveInDate.endDate = this.searchRequest.moveInDate.endDate;
          }
          if (this.searchRequest.inGateDate) {
             this.searchCriteria.inGateDate.startDate = this.searchRequest.inGateDate.startDate;
             this.searchCriteria.inGateDate.endDate = this.searchRequest.inGateDate.endDate;
          }
          this.searchCriteria.filter = this.filter;
          this.searchCriteria.fromPage = "L";
          this.searchCriteria.selectDType = this.selectDType;
          //console.log("request for cockpit: " + JSON.stringify(request));
          //request.push(this.searchCriteria);
          this.$router.push({  
            name: "cockpit" , 
            //params: { req: JSON.stringify(request) }})
            params: { req: JSON.stringify(request), searchCriteria: JSON.stringify(this.searchCriteria)}})

      },

      doBobTailEmpty() {
          if (this.searchRequest.receivingWindow == null || this.searchRequest.receivingWindow == '')
          {
             alert("Receiving Window is required to process!");
             return;
          }
          if (this.searchRequest.carrier == null || this.searchRequest.carrier == '')
          {
             alert("Carrier Name is required to process!"); 
             return;
          } else {
             alert("container num: " + this.searchRequest.carrier + "__DUMMY");
          }
          var dummyload = initDummyLoad();
          var dummyloads = [];
          dummyload.seqNo = "C000000000";
          dummyload.carrier = this.searchRequest.carrier;
          dummyload.containerNo = this.searchRequest.carrier + "__DUMMY";
          dummyload.chassisNo = this.searchRequest.carrier + "__DUMMY";
          dummyload.receivingWindow = this.searchRequest.receivingWindow;
          dummyload.ctnrType = "45G0";
          if (this.selectDType == "YE") dummyload.mode = "YY";
          if (this.selectDType == "E") dummyload.mode = "YE";
          if (this.selectDType == "I") dummyload.mode = "YI";
          if (this.selectDType == "TL") dummyload.mode = "YT";
          dummyload.handler = "BOBTAILEMPTY";
          dummyloads.push(dummyload);
          const request = this.uniqByLast(dummyloads, it => it.seqNo);
          this.searchCriteria.containerNo = this.searchRequest.containerNo;
          this.searchCriteria.receivingWindow = this.searchRequest.receivingWindow;
          this.searchCriteria.salesOffice = this.searchRequest.salesOffice;
          this.searchCriteria.pickupLocation = this.searchRequest.pickupLocation;
          this.searchCriteria.bookingNo = this.searchRequest.bookingNo;
          this.searchCriteria.destination = this.searchRequest.destination;
          this.searchCriteria.appointment = this.searchRequest.appointment;
          this.searchCriteria.driverId = this.searchRequest.driverId;
          this.searchCriteria.driverGroup = this.searchRequest.driverGroup;
          this.searchCriteria.costRelevant = this.searchRequest.costRelevant;
          this.searchCriteria.freightType = this.searchRequest.freightType;
          this.searchCriteria.loadKey = this.searchRequest.loadKey;
          this.searchCriteria.source = this.searchRequest.source;
          this.searchCriteria.chassisNo = this.searchRequest.chassisNo;
          this.searchCriteria.ctnrType = this.searchRequest.ctnrType;
          this.searchCriteria.carrier = this.searchRequest.carrier
          this.searchCriteria.customerOrder = this.searchRequest.customerOrder;
          this.searchCriteria.deliveryOrder = this.searchRequest.deliveryOrder;
          this.searchCriteria.loadStatus = this.searchRequest.loadStatus;
          this.searchCriteria.pushStatus = this.searchRequest.pushStatus;
          this.searchCriteria.stageType = this.searchRequest.stageType;
          if (this.searchRequest.cargoCutOff)
             this.searchCriteria.cargoCutOff.startDate = this.searchRequest.cargoCutOff.startDate;
          if (this.searchRequest.apptDate)   
             this.searchCriteria.apptDate.startDate = this.searchRequest.apptDate.startDate;
          if (this.searchRequest.cargoCutOff)   
             this.searchCriteria.cargoCutOff.endDate = this.searchRequest.cargoCutOff.endDate;
          if (this.searchRequest.apptDate)   
             this.searchCriteria.apptDate.endDate = this.searchRequest.apptDate.endDate;
          if (this.searchRequest.moveInDate) {   
             this.searchCriteria.moveInDate.startDate = this.searchRequest.moveInDate.startDate;
             this.searchCriteria.moveInDate.endDate = this.searchRequest.moveInDate.endDate;
          }
          if (this.searchRequest.inGateDate) {
             this.searchCriteria.inGateDate.startDate = this.searchRequest.inGateDate.startDate;
             this.searchCriteria.inGateDate.endDate = this.searchRequest.inGateDate.endDate;
          }
          this.searchCriteria.filter = this.filter;
          this.searchCriteria.fromPage = "L";
          this.searchCriteria.selectDType = this.selectDType;
          //console.log("request for cockpit: " + JSON.stringify(request));
          //request.push(this.searchCriteria);
          this.$router.push({  
            name: "cockpit" , 
            //params: { req: JSON.stringify(request) }})
            params: { req: JSON.stringify(request), searchCriteria: JSON.stringify(this.searchCriteria)}})

      },




      doStage() {
        //console.log(request);
        //console.log("getselectitems: " + JSON.stringify(this.getSelectedItems) + ", length: " + this.getSelectedItems.length);
        var request = [];
        if (this.getSelectedItems.length > 0) {
            request = this.uniqByLast(this.getSelectedItems, it => it.seqNo);
            //console.log("request: " + JSON.stringify(request) + ", length: " + request.length);
            request.forEach((it) => {
              if (this.selectDType == "YE") it.mode = "YY";
              if (this.selectDType == "E") it.mode = "YE";
              if (this.selectDType == "I") it.mode = "YI";
              if (this.selectDType == "TL") it.mode = "YT";
              //it.mode = 'YY';
              //it.carrierName = "";
              //it.customerPO = "";
              it.route = "";
              //it.deliveryOrder = "";
              //console.log("before load key to stage: " + it.loadKey + ", seqNo: " + it.seqNo);
               //if (it.loadKey == null)
               //{
               //  it.loadKey = it.seqNo;
              // }
              // console.log("load key to stage: " + it.loadKey + ", seqNo: " + it.seqNo);
            });
        }
        this.searchCriteria.containerNo = this.searchRequest.containerNo;
        this.searchCriteria.receivingWindow = this.searchRequest.receivingWindow;
        this.searchCriteria.salesOffice = this.searchRequest.salesOffice;
        this.searchCriteria.pickupLocation = this.searchRequest.pickupLocation;
        this.searchCriteria.bookingNo = this.searchRequest.bookingNo;
        this.searchCriteria.destination = this.searchRequest.destination;
        this.searchCriteria.appointment = this.searchRequest.appointment;
        this.searchCriteria.driverId = this.searchRequest.driverId;
        this.searchCriteria.driverGroup = this.searchRequest.driverGroup;
        this.searchCriteria.costRelevant = this.searchRequest.costRelevant;
        this.searchCriteria.freightType = this.searchRequest.freightType;
        this.searchCriteria.loadKey = this.searchRequest.loadKey;
        this.searchCriteria.source = this.searchRequest.source;
        this.searchCriteria.chassisNo = this.searchRequest.chassisNo;
        this.searchCriteria.ctnrType = this.searchRequest.ctnrType;
        this.searchCriteria.carrier = this.searchRequest.carrier
        this.searchCriteria.customerOrder = this.searchRequest.customerOrder;
        this.searchCriteria.deliveryOrder = this.searchRequest.deliveryOrder;
        this.searchCriteria.loadStatus = this.searchRequest.loadStatus;
        this.searchCriteria.pushStatus = this.searchRequest.pushStatus;
        this.searchCriteria.stageType = this.searchRequest.stageType;
        this.searchCriteria.cargoCutOff.startDate = this.searchRequest.cargoCutOff.startDate;
        this.searchCriteria.apptDate.startDate = this.searchRequest.apptDate.startDate;
        this.searchCriteria.cargoCutOff.endDate = this.searchRequest.cargoCutOff.endDate;
        this.searchCriteria.apptDate.endDate = this.searchRequest.apptDate.endDate;
        this.searchCriteria.moveInDate.startDate = this.searchRequest.moveInDate.startDate;
        this.searchCriteria.moveInDate.endDate = this.searchRequest.moveInDate.endDate;
        this.searchCriteria.inGateDate.startDate = this.searchRequest.inGateDate.startDate;
        this.searchCriteria.inGateDate.endDate = this.searchRequest.inGateDate.endDate;
        this.searchCriteria.filter = this.filter;
        this.searchCriteria.selectDType = this.selectDType;
        this.searchCriteria.fromPage = "L";
        this.$router.push({  
            name: "Stage" , 
            //params: { req: JSON.stringify(request) }})
            params: { req: JSON.stringify(request), searchCriteria: JSON.stringify(this.searchCriteria)}})
          
      },

       async doSave() {
        
      
        //const editItem = this.getEditingItems.filter(it  => this.hasBeenChanged(it));
        const editItem = (this.items).filter(it  => this.hasBeenChanged(it));
        //console.log("doSave editItem: " + editItem.length);
        const requests = _(editItem)
          .chain()
          .map(it => ({
            salesOffice: it.salesOffice,
            loadKeyWithStageNo: it.loadKeyWithStageNo,
            appointment: it.appointment,
            apptDate: it.apptDate,
            apptTime: it.apptTime,
            driverId: (it.driverId && it.driverId != "")? this.getDriverIdFromName(it.driverId): it.driverId,
            truckId: it.truckId,
            costRelevant: it.costRelevant,
            freightType: it.freightType,
            dispatcherInstruction: it.dispatcherInstruction,
            containerPickupLocation: it.containerPickupLocation,
            containerDropOffLocation: it.containerDropOffLocation,
            offsiteScale: it.offsiteScale,
            seqNo: it.seqNo,
            ccicDropOffLocationCode: it.ccicDropOffLocationCode,
            pickupLocationCode: it.pickupLocationCode,
            pickUpLocationName: it.pickUpLocationName,
            deliverLocationCode: it.deliverLocationCode,
            deliverLocationName: it.deliverLocationName,
            deliveryOrder: it.deliveryOrder,
            driverGroup: it.driverGroup,
            containerNo: it.containerNo,
            chassisNo: it.chassisNo,
            pushStatus: it.pushStatus,
            loadBookingGrade: it.loadBookingGrade,
            loadStatus: it.loadStatus
          })).value();
      
        // await Promise.all(this.getEditingItems.map(it => api.post('/api/w/ccic/application/update', it)));
         
         //console.log("doSave requests: " + JSON.stringify(requests));

         //api.post("/api/w/gst/updateyardstage", requests)
         newAPIPost("/api/w/gst/updateyardstage", requests)
          .then(() => {
            this.$store.commit('clearApiError');
            this.doSearch();
          });
         this.disableSave = true;
         this.isSetDriverGroup = false;
         this.isAsgDriver = false;
         this.isConfirm = false;
         this.disableAppt = true;
      },


      doEdit() {

        const confirmedStage = this.getSelectedItems.filter(it => it.stageStatus == "STC" || it.stageStatus == "SUC")
        if (confirmedStage.length != 0)
        {
           alert("Some stages have been confirmed or under check , it can not be changed at this moment!!");
          return;
        }
        this.getSelectedItems.forEach((it) => {
          it.editing = true;
        });
      },

      getBookingAssign() {
         var error = false;
         const loads = this.getSelectedItems
         if (loads.length > 0) {
           loads.forEach( (it) => {
              if (!it.carrier || it.carrier == "") error = true;
              if (!it.grade || it.grade == "") error = true;
           })
           if (error) {
             alert("WARNING: Check if no carrier and or grade in selection. Caution to process!!")
           }  
           if (loads[0].loadIndicator == null || loads[0].loadIndicator == "YY") 
              this.$refs.OutboundBooking.openDialog(loads);
           if (loads[0].loadIndicator == "YE") 
              this.$refs.OutboundBookingYE.openDialog(loads);
           if (loads[0].loadIndicator == "YI") 
              this.$refs.OutboundBookingYI.openDialog(loads);
           if (loads[0].loadIndicator == "YT") 
              this.$refs.OutboundBookingYT.openDialog(loads);
         }
      },

      getBookingUnAssign() {
         if (!window.confirm('Unassign Selected Items?')) {
           return;
         }
        
         const load = this.getSelectedItems
         const office = 'LGB'
         const si = this.getSelectedItems[0].deliveryOrder
         const obk = this.getSelectedItems[0].bookObl
         const ibds = this.getSelectedItems[0].ibs
         const usr = 'GST_SYSTEM'
         const seqn = this.getSelectedItems[0].seqNo
         //console.log("Set Unassign");
         const request = {
           salesOffice: office,
           deliveryOrder: si,
           ibs: ibds,
           user: usr,
           seqNo: seqn,
         };

         //console.log(JSON.stringify(request));
         //api.post("/api/w/DOs/WebUnAssignBooking", request).then((res) => {
         mewAPI("/api/w/DOs/WebUnAssignBooking", request).then((res) => {
            this.showDialog = false;
            this.$store.commit("clearApiError");
            //this.action(si, obk, 'UASN', seqn);
            this.doSearch();
 
         });
      },

      getChassisUsedDate(item){
          if (item.chzStartDate != null) {
          if (item.chzEndDate == null)
          {
            //return moment().diff(moment(item.chzStartDate), 'days') + 1;
            return this.getDateDiffCurr(item.chzStartDate);
          }
          else
          {
            //return moment(item.chzEndDate).diff(moment(item.chzStartDate), 'days') + 1;
            return this.getDateDiffDate(item.chzStartDate,item.chzEndDate);
          }
        } 
        else return 0;
      },

      getDateDiffCurr(date1) {
           var p_date = []
           const [month,day,year] = new Date().toLocaleDateString().split("/");
           const currDate = year + "-" + ((month.length == 1)? '0' + month : month) + "-" + ((day.length == 1)? '0' + day: day);
           //console.log("currdate: " + currDate);
           if (date1 != null) {
              // if (date1.toString().indexOf("T") > 0) {
              //    p_date = date1.toString().split("T");
              // } else {p_date[0] = date1}
              //console.log("call get time: " + this.getCurrentTime(date1));
              //console.log("date1: " + date1 + ", new date: " + new Date(this.getCurrentTime(date1)));
              //console.log("getcurrent time: " + this.getCurrentTime(currDate) + ", new curr: " + new Date(this.getCurrentTime(currDate)));
              const timeDiff = new Date(this.getCurrentTime(currDate)).getTime() - new Date(this.getCurrentTime(date1)).getTime();
              //return (Math.floor(timeDiff / (1000*60*60*24) + 1));
              return (Math.floor(timeDiff / (1000*60*60*24)) + 1);
           } else { return 0; }
      },

      getDateDiffDate(date1,date2) {
           var p_date1 = [];
           var p_date2 = [];
           //const [month,day,year] = new Date().toLocaleDateString().split("/");
           //const currDate = new Date(year + "-" + month + "-" + day);
           if (date1 != null && date2 != null) {
             if (date1.toString().indexOf("T") > 0) {
                p_date1 = date1.toString().split("T");
             } else {p_date1[0] = date1}
             if (date2.toString().indexOf("T") > 0) {
                p_date2 = date2.toString().split("T");
             } else {p_date2[0] = date2}
             //console.log("date1: " + p_date2[0] + "date2: " + p_date1[0]);
             const timeDiff = new Date(p_date2[0]).getTime() - new Date(p_date1[0]).getTime();
             return (Math.floor(timeDiff / (1000*60*60*24) + 1));
           } else {return 0;}
      },
      getCurrentTime(date) {
           var p_date_el = [];
           var p_datetime_el = [];
           var p_date = date;
           var retDate = date;
           if (date.toString().indexOf("T") > 0) {
              p_datetime_el = date.toString().split("T");
              p_date = p_datetime_el[0];
           }
           if (p_date.toString().indexOf("/") > 0) {
              p_date_el = p_date.toString().split("/");
              retDate = p_date_el[2] + "-" + p_date_el[0] + "-" + p_date_el[1];
           }     
           const currdatehour = new Date().getHours();
           const currdatemin = new Date().getMinutes();
           //console.log("hour: " + currdatehour + ", mins: " + currdatemin);               
           return retDate + "T" + currdatehour + ":" + currdatemin + ":00";
           
      },

      overPeriod(item) {
        var useday = item.ctnrUsedDay;
        return ( useday >= 5 && (item.chzEndDate == null || item.chzEndDate == ""))
      },

      getPushStatusInfo(status) {
       var retStatus = "";
       //console.log("push status: " + status);
       if (status && status != "") {
          //retType = this.getMasterDataName("STC_STAGE_TYPE",type);
          retStatus = this.getMasterDataName("PUSH_STATUS",status);
          //console.log("return type: " + retStatus);
       }
       return retStatus;     
    },

      async doOutGate(){
          const request = this.getSelectedItems;
          if (request.filter(it => it.stageType == "OUT" || it.stageType == null).length != 0)
          {
            alert("Can not out gate for this item!");
            return 
          }
          const data = request.map(it => ({
            salesOffice: it.salesOffice,
            user: it.user,
            type: it.type,
            appointment: it.appointment,
            apptDate: dateFormat.getLocalDate(it.apptDate),
            //pickupDate: dateFormat.getLocalDate(it.pickupDate),
            driverId: it.driverId,
            truckId: it.truckId,
            chassisStartDate :dateFormat.getLocalDate(moment())
          }));


          //await api.post("/api/w/gst/WebYardGroupOutGate", data)
          await newAPIPost("/api/w/gst/WebYardGroupOutGate", data)
          .then(() => {
            this.$store.commit('clearApiError');
            // $('.btn-search-loadlist-container')
            //   .click();
          });
          this.doSearch();

      },


      doDownloadExcel(){
       const request = toGenerateExcelRequest(
          this.$el.querySelector('.data-table-container .inner-container'),
          'Dispatch-Load-List.xls',
          1,
        );
          //request.heads = _(request.heads).take(52);
          console.log("excel items: " + JSON.stringify(this.items))
          request.heads = _(request.heads).take(55);
          console.log("request heads: " + request.heads);
          request.rows = _(this.items)
          .map(item => [
            (this.docCutDue >= item.docCut && (item.loadStatus == 'ASN' || item.loadStatus == 'OU' || item.loadStatus == 'DIS')) ? 'X' : '',
            item.salesOffice,
            item.loadIndicator,
            item.receivingWindow,
            item.loadStatus,
            item.stageCount,
            item.containerNo,
            item.chassisNo,
            item.additioncharge,
            item.carrier,
            item.loadBookingCarrier,
            item.grade,
            item.loadBookingGrade,
            item.specGrade,
            item.bookingNo,
            item.emptyPulledBooking,
            item.mismatchBooking,
            item.docCut,
            item.cutLFD,
            item.appointment,
            item.apptDate,
            item.apptTime,
            item.driverGroup,
            item.driverId,
            (item.pushStatus == 'P')? 'X' : '',
            (item.pushStatus == 'R')? 'X' : '',
            (item.pushStatus == 'RE')? 'X' : '',
            (item.pushStatus == 'A')? 'X' : '',
            (item.pushStatus == 'C')? 'X' : '',
            item.truckId,
            (item.driverCntrImg != null)? '1 image' : '0 image',
            item.driverRemark,
            item.bolNum,
            item.ctnrType,
            item.source,
            this.getChassisUsedDate(item) + " Days",
            //item.moveInDate,
            item.chzEndDate,
            item.inYardDate,
            item.chzEndDate,
            item.gwDate,
            item.loadKey,
            item.seqNo,
            item.yard,
            item.customerOrder,
            item.sealNumber,
            item.scaleTicket,
            this.getMasterDataByName("GST_LOCATION",item.pickupLoc),
            this.getMasterDataByName("GST_LOCATION",item.deliveryTo),
            this.getMasterDataByName("GST_TERMINAL",item.pickupTerm),
            this.getMasterDataByName("GST_TERMINAL",item.dropOffTerm),
            item.deliveryOrder,
            item.stcLoadConfirmedBy,
            dateFormat.date(item.stcLoadConfirmedAt),
            dateFormat.time(item.stcLoadConfirmedAt),
            dateFormat.date(item.gwDate),
            item.doProcess,
            item.route,
            item.routeDesc
            // item.logId,
            // item.yard,
            // item.gateTypeDesc,
            // item.gateNo,
            // item.statusTypeDesc,
            // dateFormat.date(item.logDateTime),
            // dateFormat.time(item.logDateTime),
            // item.plateNo,
            // item.plateImage,
            // item.containerNo,
            // item.containerType,
            // this.getMasterDataByName("CCR_CNTRTYPE",item.containerType),
            // this.getMasterDataByName("CCR_CNTRTYPE_ID",item.containerType),
            // item.containerImage,
            // item.chassisNo,
            // item.chassisImage,
            // item.scaleWeight,
            // item.logStatus,
            // item.status,
            // item.inboundShipment,
            // item.seqNo,
            // item.createdBy,
            // dateFormat.date(item.createdAt),
            // dateFormat.time(item.createdAt),
            // item.updatedBy,
            // dateFormat.date(item.updatedAt),
            // dateFormat.time(item.updatedAt),
            // item.salesOffice,
            // item.loadStatus,
            // item.stageStatus,
            // item.loadKey,
            // item.containerNo,
            // item.chassisNo,
            // item.carrier,
            // item.yard,
            // item.stage,
            // item.stageType,
            // item.bookingNo,
            // item.customerOrder,
            // item.ctnrType,
            // item.cutLFD,
            // //item.deliveryTo,
            // dateFormat.date(item.apptDate),
            // dateFormat.time(item.apptDate),
            // item.appointment,
            // item.driverId,
            // item.truckerId,
            // item.pickupLocationCode,
            // this.getMasterDataByName("GST_LOCATION",item.pickupLocationCode),
            // item.deliverLocationCode,
            // this.getMasterDataByName("GST_LOCATION",item.deliverLocationCode),
            // item.dispatcherInstruction,
            // item.costRelevant,
            // item.source,
            // item.freightType,
            // dateFormat.date(item.chzStartDate),
            // dateFormat.date(item.pickupDate),
            // item.deliveryOrder,
            // item.deliveryOrderItem,
            // item.customerRef,
            // item.route,
            // item.routeDesc,
            // item.createdBy,
            // dateFormat.date(item.createdAt),
            // item.updatedBy,
            // dateFormat.date(item.updatedAt),

          ]);
        this.$store.dispatch('generateExcel', request)
          .then((res) => {
            window.open(res.url, 'blank');
          });
      },




      hasBeenChanged(item) {

        const lhs = _(this.getYardExportList)
          .find(it => it.vueKey === item.vueKey);
        
        if (lhs) {
          return (moment(lhs.apptDate).format() !== moment(item.apptDate).format())
            || (lhs.driverGroup !== item.driverGroup)
            || (lhs.appointment !== item.appointment)
            || (lhs.apptTime !== item.apptTime)
            || (lhs.driverId !== item.driverId)
            || (lhs.truckId !== item.truckId)
            || (lhs.dispatcherInstruction !== item.dispatcherInstruction)
            || (lhs.costRelevant !== item.costRelevant)
            || (lhs.freightType !== item.freightType)
            || (lhs.pickupLocationCode != item.pickupLocationCode)
            || (lhs.deliverLocationCode != item.deliverLocationCode)
            || (lhs.pushStatus != item.pushStatus);
        }
        return false;
      },

     changeSelChkBox() {
        //console.log("change check box: " + this.selectAll);
        //console.log("yard export list: " +  JSON.stringify(_(this.items)));
        _(this.items).forEach(
          it => {
            //console.log("check box item: " + JSON.parse(JSON.stringify(it)));
            it.selected = this.selectAll;
          }
        );
     },

     handleDriverChanged(item) {
        return (id) => {
          item.driverId = id;
        };
      },


     convertDateForDatePicker(date, type) {
        var day = "";
        var month = "";
        var year = "";
        if (date) {
           //console.log("date input: " + date);
          //  if (date.toString().indexOf("T") > 0) {
          //     dateString = date.toString().substr(1, date.toString().indexOf("T") - 1);
          //     console.log("convert date for date picker: " + Date(dateString).getMonth());
          //     return moment(dateString);      
          //  }   
          //  else {
          //     return date;
          //  }
          if (date.indexOf("T") < 1 && date.indexOf("-") > 1) date = date + "T00:00:00" 
          var processDate = new Date(date);
          year = processDate.getFullYear();
          month = processDate.getMonth() + 1;
          day = processDate.getDate();
          if (month && month.toString().length < 2) {
             month = "0" + month;
          }
          if (day && day.toString().length < 2) {
             day = "0" + day;
          }
          //console.log("date (" + type + ") input in format: " +  month + "/" + day + "/" + year );
          return month + "/" + day + "/" + year;
        }
        else {
          //console.log("no date (" + type + ") input in format: ");
          return date;
        }
     },

     getDateDiffForDatePicker(date,offset) {
        var day = "";
        var month = "";
        var year = "";
        var newdate = new Date();
        if (date) {
           //console.log("date input: " + date);
          //  if (date.toString().indexOf("T") > 0) {
          //     dateString = date.toString().substr(1, date.toString().indexOf("T") - 1);
          //     console.log("convert date for date picker: " + Date(dateString).getMonth());
          //     return moment(dateString);      
          //  }   
          //  else {
          //     return date;
          //  }
          var processDate = new Date(date);
          if (offset && offset != 0)
             processDate.setDate(newdate.getDate() - offset);
          //console.log("process date after adjusted: " + processDate);   
          year = processDate.getFullYear();
          month = processDate.getMonth() + 1;
          day = processDate.getDate();
          if (month && month.toString().length < 2) {
             month = "0" + month;
          }
          if (day && day.toString().length < 2) {
             day = "0" + day;
          }
          //console.log("date (" + type + ") input in format: " +  month + "/" + day + "/" + year );
          return month + "/" + day + "/" + year;
        }
        else {
          //console.log("no date (" + type + ") input in format: ");
          return date;
        }
    },

    convertDateForMoveIn(date, separator) {
        var day = "";
        var month = "";
        var year = "";
        if (date) {
           //console.log("date input: " + date);
          //  if (date.toString().indexOf("T") > 0) {
          //     dateString = date.toString().substr(1, date.toString().indexOf("T") - 1);
          //     console.log("convert date for date picker: " + Date(dateString).getMonth());
          //     return moment(dateString);      
          //  }   
          //  else {
          //     return date;
          //  }
          var processDate = new Date(date);
          year = processDate.getFullYear();
          month = processDate.getMonth() + 1;
          day = processDate.getDate();
          if (month && month.toString().length < 2) {
             month = "0" + month;
          }
          if (day && day.toString().length < 2) {
             day = "0" + day;
          }
          //console.log("date (" + type + ") input in format: " +  month + "/" + day + "/" + year );
          if (separator && separator == "-")
              return year + separator + month + separator + day;
          else 
              return month + "/" + day + "/" + year;
        }
        else {
          //console.log("no date (" + type + ") input in format: ");
          return date;
        }
      },

     convertDateForCutOff(date) {
        var day = "";
        var month = "";
        var year = "";
        if (date) {
           if (date.indexOf('T') > 1) {
               var processDate = new Date(date);
               return date.substr(1,date.indexOf('T'));
           }
           else {
              return date;
           }
        }      
     }, 

     doDropDown() {
          this.showDropDown = !this.showDropDown;
      }, 


        async CreateIngate(){
            const selectedItem = this.getSelectedItems[0];
            this.$refs.DispatchForm.openDialog(selectedItem);
        //     const req = {
        //       companyOffice: 'GST_' + selectedItem.salesOffice,
        //       loadKey: selectedItem.seqNo,
        //       stageType: 'IN',
        //       stageTypeWithStatus: 'YY'
        //     }
        //  await  api.post("/api/w/gst/createyardstage", req)
        //   .then(() => {
        //     this.$store.commit('clearApiError');
        //     // $('.btn-search-loadlist-container')
        //     //   .click();
        //   });

         // this.doSearch();


           

        },

      toggleCreateIngate(item) {
       
        if (!!_(this.getEditingItems).find(it => !!this.hasBeenChanged(it)))
        {
            alert("Please save stages changes first!!");
          return;
        }

        if (item.bookingNo != null) return 

        //const selectedItem = this.getSelectedItems[0];
        this.$refs.CreateIngate.openDialog(item);

      
      },


      toggleInstruction(item) {

        if (item.editing == false)
        return 

        this.$refs.Instruction.openDialog(item);
      },

        //getChassisUsedDate(date){
        //    return moment().diff(moment(date), 'days')
        //
        //},



        mouseOver: function(){
            this.active = true;
        },

        mouseLeave: function() {
         
          this.active = !this.active;
        },


        getDriverName(item){
            const driver = this.drivers.filter(it => it.id == item);
          
            return  driver.length == 0 ? "" : driver[0].name
        },


      handleScroll(e) {
        this.$nextTick(() => {
          if (this.$el && this.$el.querySelector)
          {
             $(this.$el.querySelector('.table-header'))
               .offset({
               left: -1 * (e.target.scrollLeft - $('.outer-container')
                 .offset().left),
             });
          }   
        });  
      },


      uniqByLast(data, key){
        return [
          ...new Map(
            data.map(x => [key(x), x])
          ).values()
        ]
      },


      includeNull(field){
            return field==null ? '' : field;
      },

      isValidCond(values) {
         if (values == null) return false;
         if (values[0])
            return (values.length === 1 && values[0].toString() != "");
         else
            return false;   
      }
      

     },

    }
    // function getDriverFromId(id) {
    //     // if (this.driverIds && this.driverContent && id) {
    //     //     var indx = 0;
    //     //     var storedindx = 0;
    //     //     driverIds.forEach((it) => {
    //     //       if (it.driverId != id) {
    //     //           indx += 1;
    //     //       }
    //     //       else {
    //     //         storedindx = indx;
    //     //       }
    //     //     })
    //     //     return this.driverContent[storedindx];
    //     // }
    //     // else {
    //     //   return null;
    //     // }
    //     return id;
    // }

</script>